// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/runner_interaction.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import type { AgentExecution, AgentExecution_Status, AgentMessage, SupportedModel, UserInputBlock, WakeEvent } from "./agent_pb";
import { file_gitpod_v1_agent } from "./agent_pb";
import type { EnvironmentActivitySignal, EnvironmentMetadata, EnvironmentSpec, EnvironmentStatus } from "./environment_pb";
import { file_gitpod_v1_environment } from "./environment_pb";
import type { Integration } from "./integration_pb";
import { file_gitpod_v1_integration } from "./integration_pb";
import type { BigPaginationRequest, PaginationRequest, PaginationResponse } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import type { WarmPool, WarmPoolStatus } from "./prebuild_pb";
import { file_gitpod_v1_prebuild } from "./prebuild_pb";
import type { CheckAuthenticationForHostResponse, CheckRepositoryAccessResponse, GatewayInfo, ListSCMOrganizationsResponse_SCMOrganization, LogLevel, ParseContextURLResponse, RunnerCapability, RunnerReleaseChannel, SearchMode, SearchRepositoriesResponse_Repository, UpdateWindow } from "./runner_pb";
import { file_gitpod_v1_runner } from "./runner_pb";
import type { EnvironmentClass, EnvironmentClassValidationResult, FieldValueUpdate, HostAuthenticationTokenSource, LLMIntegration, RunnerConfigurationSchema, SCMIntegration, SCMIntegrationValidationResult } from "./runner_configuration_pb";
import { file_gitpod_v1_runner_configuration } from "./runner_configuration_pb";
import type { Any, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_any, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/runner_interaction.proto.
 */
export const file_gitpod_v1_runner_interaction: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_v1_agent, file_gitpod_v1_environment, file_gitpod_v1_integration, file_gitpod_v1_pagination, file_gitpod_v1_prebuild, file_gitpod_v1_runner, file_gitpod_v1_runner_configuration, file_google_protobuf_any, file_google_protobuf_timestamp]);

/**
 * @generated from message gitpod.v1.SignupRequest
 */
export type SignupRequest = Message<"gitpod.v1.SignupRequest"> & {
  /**
   * The runner's public key. Must be an ECDH public key encoded in PKIX, ASN.1 DER format.
   *
   * @generated from field: bytes public_key = 1;
   */
  publicKey: Uint8Array;

  /**
   * The environment classes this runner has to offer
   *
   * @generated from field: repeated gitpod.v1.EnvironmentClass environment_classes = 2;
   */
  environmentClasses: EnvironmentClass[];
};

/**
 * Describes the message gitpod.v1.SignupRequest.
 * Use `create(SignupRequestSchema)` to create a new message.
 */
export const SignupRequestSchema: GenMessage<SignupRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 0);

/**
 * @generated from message gitpod.v1.SignupResponse
 */
export type SignupResponse = Message<"gitpod.v1.SignupResponse"> & {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;
};

/**
 * Describes the message gitpod.v1.SignupResponse.
 * Use `create(SignupResponseSchema)` to create a new message.
 */
export const SignupResponseSchema: GenMessage<SignupResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 1);

/**
 * @generated from message gitpod.v1.MarkRunnerActiveRequest
 */
export type MarkRunnerActiveRequest = Message<"gitpod.v1.MarkRunnerActiveRequest"> & {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;
};

/**
 * Describes the message gitpod.v1.MarkRunnerActiveRequest.
 * Use `create(MarkRunnerActiveRequestSchema)` to create a new message.
 */
export const MarkRunnerActiveRequestSchema: GenMessage<MarkRunnerActiveRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 2);

/**
 * @generated from message gitpod.v1.MarkRunnerActiveResponse
 */
export type MarkRunnerActiveResponse = Message<"gitpod.v1.MarkRunnerActiveResponse"> & {
};

/**
 * Describes the message gitpod.v1.MarkRunnerActiveResponse.
 * Use `create(MarkRunnerActiveResponseSchema)` to create a new message.
 */
export const MarkRunnerActiveResponseSchema: GenMessage<MarkRunnerActiveResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 3);

/**
 * @generated from message gitpod.v1.ListRunnerEnvironmentsRequest
 */
export type ListRunnerEnvironmentsRequest = Message<"gitpod.v1.ListRunnerEnvironmentsRequest"> & {
  /**
   * pagination contains the pagination options for listing environments
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * The runner's identifier
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId: string;

  /**
   * An optional list of environment IDs to fetch. If this list is empty/not provided
   * all environments that ought to run on the runner are returned.
   *
   * @generated from field: repeated string environment_ids = 3;
   */
  environmentIds: string[];
};

/**
 * Describes the message gitpod.v1.ListRunnerEnvironmentsRequest.
 * Use `create(ListRunnerEnvironmentsRequestSchema)` to create a new message.
 */
export const ListRunnerEnvironmentsRequestSchema: GenMessage<ListRunnerEnvironmentsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 4);

/**
 * @generated from message gitpod.v1.RunnerEnvironment
 */
export type RunnerEnvironment = Message<"gitpod.v1.RunnerEnvironment"> & {
  /**
   * ID is a unique identifier of this environment. No other environment with the same name must be managed by this
   * environment manager
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Metadata is data associated with this environment that's required for other parts of Gitpod to function
   *
   * @generated from field: gitpod.v1.EnvironmentMetadata metadata = 2;
   */
  metadata?: EnvironmentMetadata;

  /**
   * Spec is the configuration of the environment that's required for the runner to start the environment
   *
   * @generated from field: gitpod.v1.EnvironmentSpec spec = 3;
   */
  spec?: EnvironmentSpec;

  /**
   * The environment's access token
   *
   * @generated from field: string environment_access_token = 4;
   */
  environmentAccessToken: string;

  /**
   * The last activity signal received by the management plane
   *
   * @generated from field: gitpod.v1.EnvironmentActivitySignal activity_signal = 5;
   */
  activitySignal?: EnvironmentActivitySignal;

  /**
   * The SCM contexts for the environment
   *
   * @generated from field: repeated gitpod.v1.SCMContext scm_contexts = 6;
   */
  scmContexts: SCMContext[];

  /**
   * startup_trace_context contains trace headers for the root startup trace
   * to propagate trace context to runners for end-to-end tracing
   *
   * @generated from field: map<string, string> startup_trace_context = 7;
   */
  startupTraceContext: { [key: string]: string };

  /**
   * snapshot_id specifies an existing environment snapshot to use when creating the environment.
   * If present, the runner will attempt to use the referenced snapshot to create the environment,
   * and otherwise fall back to normal environment creation.
   *
   * @generated from field: string snapshot_id = 8;
   */
  snapshotId: string;
};

/**
 * Describes the message gitpod.v1.RunnerEnvironment.
 * Use `create(RunnerEnvironmentSchema)` to create a new message.
 */
export const RunnerEnvironmentSchema: GenMessage<RunnerEnvironment> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 5);

/**
 * @generated from message gitpod.v1.SCMContext
 */
export type SCMContext = Message<"gitpod.v1.SCMContext"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string host = 2;
   */
  host: string;

  /**
   * @generated from field: string username = 3;
   */
  username: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: string remote_uri = 5;
   */
  remoteUri: string;
};

/**
 * Describes the message gitpod.v1.SCMContext.
 * Use `create(SCMContextSchema)` to create a new message.
 */
export const SCMContextSchema: GenMessage<SCMContext> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 6);

/**
 * @generated from message gitpod.v1.ListRunnerEnvironmentsResponse
 */
export type ListRunnerEnvironmentsResponse = Message<"gitpod.v1.ListRunnerEnvironmentsResponse"> & {
  /**
   * pagination contains the pagination options for listing environments
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The environments running on the runner
   *
   * @generated from field: repeated gitpod.v1.RunnerEnvironment environments = 2;
   */
  environments: RunnerEnvironment[];
};

/**
 * Describes the message gitpod.v1.ListRunnerEnvironmentsResponse.
 * Use `create(ListRunnerEnvironmentsResponseSchema)` to create a new message.
 */
export const ListRunnerEnvironmentsResponseSchema: GenMessage<ListRunnerEnvironmentsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 7);

/**
 * @generated from message gitpod.v1.GetRunnerEnvironmentRequest
 */
export type GetRunnerEnvironmentRequest = Message<"gitpod.v1.GetRunnerEnvironmentRequest"> & {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * The environment's ID
   *
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;
};

/**
 * Describes the message gitpod.v1.GetRunnerEnvironmentRequest.
 * Use `create(GetRunnerEnvironmentRequestSchema)` to create a new message.
 */
export const GetRunnerEnvironmentRequestSchema: GenMessage<GetRunnerEnvironmentRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 8);

/**
 * @generated from message gitpod.v1.GetRunnerEnvironmentResponse
 */
export type GetRunnerEnvironmentResponse = Message<"gitpod.v1.GetRunnerEnvironmentResponse"> & {
  /**
   * @generated from field: gitpod.v1.RunnerEnvironment environment = 1;
   */
  environment?: RunnerEnvironment;
};

/**
 * Describes the message gitpod.v1.GetRunnerEnvironmentResponse.
 * Use `create(GetRunnerEnvironmentResponseSchema)` to create a new message.
 */
export const GetRunnerEnvironmentResponseSchema: GenMessage<GetRunnerEnvironmentResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 9);

/**
 * @generated from message gitpod.v1.UpdateRunnerEnvironmentStatusRequest
 */
export type UpdateRunnerEnvironmentStatusRequest = Message<"gitpod.v1.UpdateRunnerEnvironmentStatusRequest"> & {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * The environment's ID
   *
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * The environment's status
   *
   * @generated from field: gitpod.v1.EnvironmentStatus status = 3;
   */
  status?: EnvironmentStatus;
};

/**
 * Describes the message gitpod.v1.UpdateRunnerEnvironmentStatusRequest.
 * Use `create(UpdateRunnerEnvironmentStatusRequestSchema)` to create a new message.
 */
export const UpdateRunnerEnvironmentStatusRequestSchema: GenMessage<UpdateRunnerEnvironmentStatusRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 10);

/**
 * @generated from message gitpod.v1.UpdateRunnerEnvironmentStatusResponse
 */
export type UpdateRunnerEnvironmentStatusResponse = Message<"gitpod.v1.UpdateRunnerEnvironmentStatusResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateRunnerEnvironmentStatusResponse.
 * Use `create(UpdateRunnerEnvironmentStatusResponseSchema)` to create a new message.
 */
export const UpdateRunnerEnvironmentStatusResponseSchema: GenMessage<UpdateRunnerEnvironmentStatusResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 11);

/**
 * @generated from message gitpod.v1.UpdateRunnerStatusRequest
 */
export type UpdateRunnerStatusRequest = Message<"gitpod.v1.UpdateRunnerStatusRequest"> & {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * version is the version of the runner. This is used to detect if the runner is outdated.
   *
   * @generated from field: optional string version = 2;
   */
  version?: string;

  /**
   * system_details is a runner specific system detail string. Think of this like a user agent string.
   * It's intended to be used for debugging and support purposes and might be shown to the user.
   *
   * @generated from field: optional string system_details = 4;
   */
  systemDetails?: string;

  /**
   * log_url is the URL to the runner's logs
   *
   * @generated from field: optional string log_url = 5;
   */
  logUrl?: string;

  /**
   * Degredation message is an optional message that is shown to users when the runner is in a degraded state.
   * Setting this to "" changes the runner's phase back from "degraded" to "active".
   *
   * @generated from field: optional string degredation_message = 6;
   */
  degredationMessage?: string;

  /**
   * region is the region the runner is running in, if applicable.
   *
   * @generated from field: optional string region = 7;
   */
  region?: string;

  /**
   * additional_info updates fields in the runner's additional_info.
   *
   * @generated from field: repeated gitpod.v1.FieldValueUpdate additional_info = 8;
   */
  additionalInfo: FieldValueUpdate[];

  /**
   * capabilities contains the runner's supported capabilities.
   * Optional field, only overwrites previous capabilities if set to a non-empty list.
   * To clear capabilities, set this to a list with a single UNSPECIFIED capability.
   *
   * @generated from field: repeated gitpod.v1.RunnerCapability capabilities = 9;
   */
  capabilities: RunnerCapability[];

  /**
   * GatewayInfo contains information about the gateway that the runner is running on.
   *
   * @generated from field: gitpod.v1.GatewayInfo gateway_info = 10;
   */
  gatewayInfo?: GatewayInfo;

  /**
   * llm_url is the URL of the LLM service to which the runner is connected.
   *
   * @generated from field: optional string llm_url = 11;
   */
  llmUrl?: string;

  /**
   * @generated from field: optional string support_bundle_url = 12;
   */
  supportBundleUrl?: string;
};

/**
 * Describes the message gitpod.v1.UpdateRunnerStatusRequest.
 * Use `create(UpdateRunnerStatusRequestSchema)` to create a new message.
 */
export const UpdateRunnerStatusRequestSchema: GenMessage<UpdateRunnerStatusRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 12);

/**
 * @generated from message gitpod.v1.UpdateRunnerStatusResponse
 */
export type UpdateRunnerStatusResponse = Message<"gitpod.v1.UpdateRunnerStatusResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateRunnerStatusResponse.
 * Use `create(UpdateRunnerStatusResponseSchema)` to create a new message.
 */
export const UpdateRunnerStatusResponseSchema: GenMessage<UpdateRunnerStatusResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 13);

/**
 * @generated from message gitpod.v1.UpdateRunnerConfigurationSchemaRequest
 */
export type UpdateRunnerConfigurationSchemaRequest = Message<"gitpod.v1.UpdateRunnerConfigurationSchemaRequest"> & {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * config_schema is the schema for the runner's configuration
   *
   * @generated from field: gitpod.v1.RunnerConfigurationSchema config_schema = 2;
   */
  configSchema?: RunnerConfigurationSchema;
};

/**
 * Describes the message gitpod.v1.UpdateRunnerConfigurationSchemaRequest.
 * Use `create(UpdateRunnerConfigurationSchemaRequestSchema)` to create a new message.
 */
export const UpdateRunnerConfigurationSchemaRequestSchema: GenMessage<UpdateRunnerConfigurationSchemaRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 14);

/**
 * @generated from message gitpod.v1.UpdateRunnerConfigurationSchemaResponse
 */
export type UpdateRunnerConfigurationSchemaResponse = Message<"gitpod.v1.UpdateRunnerConfigurationSchemaResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateRunnerConfigurationSchemaResponse.
 * Use `create(UpdateRunnerConfigurationSchemaResponseSchema)` to create a new message.
 */
export const UpdateRunnerConfigurationSchemaResponseSchema: GenMessage<UpdateRunnerConfigurationSchemaResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 15);

/**
 * @generated from message gitpod.v1.GetHostAuthenticationTokenValueRequest
 */
export type GetHostAuthenticationTokenValueRequest = Message<"gitpod.v1.GetHostAuthenticationTokenValueRequest"> & {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * The principal's ID to get the authentication token for
   *
   * @generated from field: string principal_id = 2;
   */
  principalId: string;

  /**
   * The host to get the authentication token for
   *
   * @generated from field: string host = 3;
   */
  host: string;
};

/**
 * Describes the message gitpod.v1.GetHostAuthenticationTokenValueRequest.
 * Use `create(GetHostAuthenticationTokenValueRequestSchema)` to create a new message.
 */
export const GetHostAuthenticationTokenValueRequestSchema: GenMessage<GetHostAuthenticationTokenValueRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 16);

/**
 * @generated from message gitpod.v1.GetHostAuthenticationTokenValueResponse
 */
export type GetHostAuthenticationTokenValueResponse = Message<"gitpod.v1.GetHostAuthenticationTokenValueResponse"> & {
  /**
   * The authentication token encrypted as NaCL anonymous sealed box using the runner's public key
   *
   * @generated from field: bytes value = 1;
   */
  value: Uint8Array;

  /**
   * The host authentication token's ID
   *
   * @generated from field: string token_id = 2;
   */
  tokenId: string;

  /**
   * The host authentication token's expiry
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp;

  /**
   * The host authentication token's refresh token encrypted as NaCL anonymous sealed box using the runner's public key
   *
   * @generated from field: bytes refresh_token = 4;
   */
  refreshToken: Uint8Array;

  /**
   * The host authentication token's source
   *
   * @generated from field: gitpod.v1.HostAuthenticationTokenSource source = 5;
   */
  source: HostAuthenticationTokenSource;

  /**
   * The host authentication token's external user ID, if known.
   *
   * @generated from field: optional string external_user_id = 6;
   */
  externalUserId?: string;
};

/**
 * Describes the message gitpod.v1.GetHostAuthenticationTokenValueResponse.
 * Use `create(GetHostAuthenticationTokenValueResponseSchema)` to create a new message.
 */
export const GetHostAuthenticationTokenValueResponseSchema: GenMessage<GetHostAuthenticationTokenValueResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 17);

/**
 * @generated from message gitpod.v1.ListRunnerEnvironmentClassesRequest
 */
export type ListRunnerEnvironmentClassesRequest = Message<"gitpod.v1.ListRunnerEnvironmentClassesRequest"> & {
  /**
   * pagination contains the pagination options for listing environment classes
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId: string;

  /**
   * @generated from field: gitpod.v1.ListRunnerEnvironmentClassesRequest.Filter filter = 3;
   */
  filter?: ListRunnerEnvironmentClassesRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListRunnerEnvironmentClassesRequest.
 * Use `create(ListRunnerEnvironmentClassesRequestSchema)` to create a new message.
 */
export const ListRunnerEnvironmentClassesRequestSchema: GenMessage<ListRunnerEnvironmentClassesRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 18);

/**
 * @generated from message gitpod.v1.ListRunnerEnvironmentClassesRequest.Filter
 */
export type ListRunnerEnvironmentClassesRequest_Filter = Message<"gitpod.v1.ListRunnerEnvironmentClassesRequest.Filter"> & {
  /**
   * environment_class_ids filters the response to only environment classes with these IDs
   *
   * @generated from field: repeated string environment_class_ids = 1;
   */
  environmentClassIds: string[];
};

/**
 * Describes the message gitpod.v1.ListRunnerEnvironmentClassesRequest.Filter.
 * Use `create(ListRunnerEnvironmentClassesRequest_FilterSchema)` to create a new message.
 */
export const ListRunnerEnvironmentClassesRequest_FilterSchema: GenMessage<ListRunnerEnvironmentClassesRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 18, 0);

/**
 * @generated from message gitpod.v1.ListRunnerEnvironmentClassesResponse
 */
export type ListRunnerEnvironmentClassesResponse = Message<"gitpod.v1.ListRunnerEnvironmentClassesResponse"> & {
  /**
   * pagination contains the pagination options for listing environment classes
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The environment classes configured for the runner
   *
   * @generated from field: repeated gitpod.v1.EnvironmentClass environment_classes = 2;
   */
  environmentClasses: EnvironmentClass[];
};

/**
 * Describes the message gitpod.v1.ListRunnerEnvironmentClassesResponse.
 * Use `create(ListRunnerEnvironmentClassesResponseSchema)` to create a new message.
 */
export const ListRunnerEnvironmentClassesResponseSchema: GenMessage<ListRunnerEnvironmentClassesResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 19);

/**
 * @generated from message gitpod.v1.ListRunnerSCMIntegrationsRequest
 */
export type ListRunnerSCMIntegrationsRequest = Message<"gitpod.v1.ListRunnerSCMIntegrationsRequest"> & {
  /**
   * pagination contains the pagination options for listing SCM integrations
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId: string;

  /**
   * @generated from field: gitpod.v1.ListRunnerSCMIntegrationsRequest.Filter filter = 3;
   */
  filter?: ListRunnerSCMIntegrationsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListRunnerSCMIntegrationsRequest.
 * Use `create(ListRunnerSCMIntegrationsRequestSchema)` to create a new message.
 */
export const ListRunnerSCMIntegrationsRequestSchema: GenMessage<ListRunnerSCMIntegrationsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 20);

/**
 * @generated from message gitpod.v1.ListRunnerSCMIntegrationsRequest.Filter
 */
export type ListRunnerSCMIntegrationsRequest_Filter = Message<"gitpod.v1.ListRunnerSCMIntegrationsRequest.Filter"> & {
  /**
   * environment_class_ids filters the response to only SCM integrations with these IDs
   *
   * @generated from field: repeated string scm_integration_ids = 1;
   */
  scmIntegrationIds: string[];
};

/**
 * Describes the message gitpod.v1.ListRunnerSCMIntegrationsRequest.Filter.
 * Use `create(ListRunnerSCMIntegrationsRequest_FilterSchema)` to create a new message.
 */
export const ListRunnerSCMIntegrationsRequest_FilterSchema: GenMessage<ListRunnerSCMIntegrationsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 20, 0);

/**
 * @generated from message gitpod.v1.ListRunnerSCMIntegrationsResponse
 */
export type ListRunnerSCMIntegrationsResponse = Message<"gitpod.v1.ListRunnerSCMIntegrationsResponse"> & {
  /**
   * pagination contains the pagination options for listing SCM integrations
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The SCM integrations configured for the runner
   *
   * @generated from field: repeated gitpod.v1.SCMIntegration scm_integrations = 2;
   */
  scmIntegrations: SCMIntegration[];
};

/**
 * Describes the message gitpod.v1.ListRunnerSCMIntegrationsResponse.
 * Use `create(ListRunnerSCMIntegrationsResponseSchema)` to create a new message.
 */
export const ListRunnerSCMIntegrationsResponseSchema: GenMessage<ListRunnerSCMIntegrationsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 21);

/**
 * @generated from message gitpod.v1.WatchRequestsRequest
 */
export type WatchRequestsRequest = Message<"gitpod.v1.WatchRequestsRequest"> & {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;
};

/**
 * Describes the message gitpod.v1.WatchRequestsRequest.
 * Use `create(WatchRequestsRequestSchema)` to create a new message.
 */
export const WatchRequestsRequestSchema: GenMessage<WatchRequestsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 22);

/**
 * @generated from message gitpod.v1.WatchRequestsResponse
 */
export type WatchRequestsResponse = Message<"gitpod.v1.WatchRequestsResponse"> & {
  /**
   * The request's ID
   *
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * trace_context carries W3C trace context (traceparent/tracestate) for
   * distributed tracing across the Redis bridge. The keys match the standard
   * HTTP header names used by the OTEL propagator.
   *
   * @generated from field: map<string, string> trace_context = 2;
   */
  traceContext: { [key: string]: string };

  /**
   * The request to handle
   *
   * @generated from oneof gitpod.v1.WatchRequestsResponse.request
   */
  request: {
    /**
     * @generated from field: gitpod.v1.EventEnvironmentSpecChange event_environment_spec_change = 10;
     */
    value: EventEnvironmentSpecChange;
    case: "eventEnvironmentSpecChange";
  } | {
    /**
     * @generated from field: gitpod.v1.EventEnvironmentMarkedActive event_environment_marked_active = 11;
     */
    value: EventEnvironmentMarkedActive;
    case: "eventEnvironmentMarkedActive";
  } | {
    /**
     * @generated from field: gitpod.v1.EventSCMIntegrationChange event_scm_integration_change = 12;
     */
    value: EventSCMIntegrationChange;
    case: "eventScmIntegrationChange";
  } | {
    /**
     * @generated from field: gitpod.v1.EventHostAuthenticationTokenDeleted event_host_authentication_token_deleted = 13;
     */
    value: EventHostAuthenticationTokenDeleted;
    case: "eventHostAuthenticationTokenDeleted";
  } | {
    /**
     * @generated from field: gitpod.v1.EventAgentExecutionSpecChange event_agent_execution_spec_change = 14;
     */
    value: EventAgentExecutionSpecChange;
    case: "eventAgentExecutionSpecChange";
  } | {
    /**
     * @generated from field: gitpod.v1.EventLLMIntegrationChange event_llm_integration_change = 15;
     */
    value: EventLLMIntegrationChange;
    case: "eventLlmIntegrationChange";
  } | {
    /**
     * @generated from field: gitpod.v1.EventRunnerConfigurationChange event_runner_configuration_change = 16;
     */
    value: EventRunnerConfigurationChange;
    case: "eventRunnerConfigurationChange";
  } | {
    /**
     * @generated from field: gitpod.v1.EventIntegrationChange event_integration_change = 17;
     */
    value: EventIntegrationChange;
    case: "eventIntegrationChange";
  } | {
    /**
     * @generated from field: gitpod.v1.EventSnapshotSpecChange event_snapshot_spec_change = 18;
     */
    value: EventSnapshotSpecChange;
    case: "eventSnapshotSpecChange";
  } | {
    /**
     * @generated from field: gitpod.v1.EventWarmPoolSpecChange event_warm_pool_spec_change = 19;
     */
    value: EventWarmPoolSpecChange;
    case: "eventWarmPoolSpecChange";
  } | {
    /**
     * @generated from field: gitpod.v1.CallParseContext.Request call_parse_context = 50;
     */
    value: CallParseContext_Request;
    case: "callParseContext";
  } | {
    /**
     * @generated from field: gitpod.v1.CallPing.Request call_ping = 51;
     */
    value: CallPing_Request;
    case: "callPing";
  } | {
    /**
     * @generated from field: gitpod.v1.CallCheckAuthenticationForHost.Request call_check_authentication_for_host = 52;
     */
    value: CallCheckAuthenticationForHost_Request;
    case: "callCheckAuthenticationForHost";
  } | {
    /**
     * @generated from field: gitpod.v1.CallValidateConfig.Request call_validate_config = 53;
     */
    value: CallValidateConfig_Request;
    case: "callValidateConfig";
  } | {
    /**
     * @generated from field: gitpod.v1.CallSendMessageToAgentExecution.Request call_send_message_to_agent_execution = 54;
     */
    value: CallSendMessageToAgentExecution_Request;
    case: "callSendMessageToAgentExecution";
  } | {
    /**
     * @generated from field: gitpod.v1.CallImprovePromptForAgent.Request call_improve_prompt_for_agent = 55;
     */
    value: CallImprovePromptForAgent_Request;
    case: "callImprovePromptForAgent";
  } | {
    /**
     * @generated from field: gitpod.v1.CallSearchRepositories.Request call_search_repositories = 60;
     */
    value: CallSearchRepositories_Request;
    case: "callSearchRepositories";
  } | {
    /**
     * @generated from field: gitpod.v1.CallListSCMOrganizations.Request call_list_scm_organizations = 61;
     */
    value: CallListSCMOrganizations_Request;
    case: "callListScmOrganizations";
  } | {
    /**
     * @generated from field: gitpod.v1.CallCheckRepositoryAccess.Request call_check_repository_access = 62;
     */
    value: CallCheckRepositoryAccess_Request;
    case: "callCheckRepositoryAccess";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.WatchRequestsResponse.
 * Use `create(WatchRequestsResponseSchema)` to create a new message.
 */
export const WatchRequestsResponseSchema: GenMessage<WatchRequestsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 23);

/**
 * @generated from message gitpod.v1.SendResponseRequest
 */
export type SendResponseRequest = Message<"gitpod.v1.SendResponseRequest"> & {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * The request's ID we're responding to
   *
   * @generated from field: string request_id = 2;
   */
  requestId: string;

  /**
   * The response to send
   *
   * @generated from oneof gitpod.v1.SendResponseRequest.response
   */
  response: {
    /**
     * @generated from field: gitpod.v1.SendResponseRequest.CallError error = 5;
     */
    value: SendResponseRequest_CallError;
    case: "error";
  } | {
    /**
     * @generated from field: gitpod.v1.CallParseContext.Response call_parse_context = 50;
     */
    value: CallParseContext_Response;
    case: "callParseContext";
  } | {
    /**
     * @generated from field: gitpod.v1.CallPing.Response call_ping = 51;
     */
    value: CallPing_Response;
    case: "callPing";
  } | {
    /**
     * @generated from field: gitpod.v1.CallCheckAuthenticationForHost.Response call_check_authentication_for_host = 52;
     */
    value: CallCheckAuthenticationForHost_Response;
    case: "callCheckAuthenticationForHost";
  } | {
    /**
     * @generated from field: gitpod.v1.CallValidateConfig.Response call_validate_config = 53;
     */
    value: CallValidateConfig_Response;
    case: "callValidateConfig";
  } | {
    /**
     * @generated from field: gitpod.v1.CallSendMessageToAgentExecution.Response call_send_message_to_agent_execution = 54;
     */
    value: CallSendMessageToAgentExecution_Response;
    case: "callSendMessageToAgentExecution";
  } | {
    /**
     * @generated from field: gitpod.v1.CallImprovePromptForAgent.Response call_improve_prompt_for_agent = 55;
     */
    value: CallImprovePromptForAgent_Response;
    case: "callImprovePromptForAgent";
  } | {
    /**
     * @generated from field: gitpod.v1.CallSearchRepositories.Response call_search_repositories = 60;
     */
    value: CallSearchRepositories_Response;
    case: "callSearchRepositories";
  } | {
    /**
     * @generated from field: gitpod.v1.CallListSCMOrganizations.Response call_list_scm_organizations = 61;
     */
    value: CallListSCMOrganizations_Response;
    case: "callListScmOrganizations";
  } | {
    /**
     * @generated from field: gitpod.v1.CallCheckRepositoryAccess.Response call_check_repository_access = 62;
     */
    value: CallCheckRepositoryAccess_Response;
    case: "callCheckRepositoryAccess";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.SendResponseRequest.
 * Use `create(SendResponseRequestSchema)` to create a new message.
 */
export const SendResponseRequestSchema: GenMessage<SendResponseRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 24);

/**
 * @generated from message gitpod.v1.SendResponseRequest.CallError
 */
export type SendResponseRequest_CallError = Message<"gitpod.v1.SendResponseRequest.CallError"> & {
  /**
   * The error's code
   *
   * @generated from field: gitpod.v1.SendResponseRequest.ErrorCode code = 1;
   */
  code: SendResponseRequest_ErrorCode;

  /**
   * The error's message
   *
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * Error details
   *
   * @generated from field: repeated google.protobuf.Any details = 3;
   */
  details: Any[];
};

/**
 * Describes the message gitpod.v1.SendResponseRequest.CallError.
 * Use `create(SendResponseRequest_CallErrorSchema)` to create a new message.
 */
export const SendResponseRequest_CallErrorSchema: GenMessage<SendResponseRequest_CallError> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 24, 0);

/**
 * @generated from enum gitpod.v1.SendResponseRequest.ErrorCode
 */
export enum SendResponseRequest_ErrorCode {
  /**
   * @generated from enum value: ERROR_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ERROR_CODE_CANCELED = 1;
   */
  CANCELED = 1,

  /**
   * @generated from enum value: ERROR_CODE_INVALID_ARGUMENT = 3;
   */
  INVALID_ARGUMENT = 3,

  /**
   * @generated from enum value: ERROR_CODE_DEADLINE_EXCEEDED = 4;
   */
  DEADLINE_EXCEEDED = 4,

  /**
   * @generated from enum value: ERROR_CODE_NOT_FOUND = 5;
   */
  NOT_FOUND = 5,

  /**
   * @generated from enum value: ERROR_CODE_ALREADY_EXISTS = 6;
   */
  ALREADY_EXISTS = 6,

  /**
   * @generated from enum value: ERROR_CODE_PERMISSION_DENIED = 7;
   */
  PERMISSION_DENIED = 7,

  /**
   * @generated from enum value: ERROR_CODE_RESOURCE_EXHAUSTED = 8;
   */
  RESOURCE_EXHAUSTED = 8,

  /**
   * @generated from enum value: ERROR_CODE_FAILED_PRECONDITION = 9;
   */
  FAILED_PRECONDITION = 9,

  /**
   * @generated from enum value: ERROR_CODE_UNIMPLEMENTED = 12;
   */
  UNIMPLEMENTED = 12,

  /**
   * @generated from enum value: ERROR_CODE_UNAVAILABLE = 14;
   */
  UNAVAILABLE = 14,

  /**
   * @generated from enum value: ERROR_CODE_UNAUTHENTICATED = 16;
   */
  UNAUTHENTICATED = 16,
}

/**
 * Describes the enum gitpod.v1.SendResponseRequest.ErrorCode.
 */
export const SendResponseRequest_ErrorCodeSchema: GenEnum<SendResponseRequest_ErrorCode> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_runner_interaction, 24, 0);

/**
 * @generated from message gitpod.v1.SendResponseResponse
 */
export type SendResponseResponse = Message<"gitpod.v1.SendResponseResponse"> & {
};

/**
 * Describes the message gitpod.v1.SendResponseResponse.
 * Use `create(SendResponseResponseSchema)` to create a new message.
 */
export const SendResponseResponseSchema: GenMessage<SendResponseResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 25);

/**
 * @generated from message gitpod.v1.EventEnvironmentSpecChange
 */
export type EventEnvironmentSpecChange = Message<"gitpod.v1.EventEnvironmentSpecChange"> & {
  /**
   * The environment's ID
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;
};

/**
 * Describes the message gitpod.v1.EventEnvironmentSpecChange.
 * Use `create(EventEnvironmentSpecChangeSchema)` to create a new message.
 */
export const EventEnvironmentSpecChangeSchema: GenMessage<EventEnvironmentSpecChange> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 26);

/**
 * @generated from message gitpod.v1.EventEnvironmentMarkedActive
 */
export type EventEnvironmentMarkedActive = Message<"gitpod.v1.EventEnvironmentMarkedActive"> & {
  /**
   * The environment's ID
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;
};

/**
 * Describes the message gitpod.v1.EventEnvironmentMarkedActive.
 * Use `create(EventEnvironmentMarkedActiveSchema)` to create a new message.
 */
export const EventEnvironmentMarkedActiveSchema: GenMessage<EventEnvironmentMarkedActive> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 27);

/**
 * @generated from message gitpod.v1.EventSCMIntegrationChange
 */
export type EventSCMIntegrationChange = Message<"gitpod.v1.EventSCMIntegrationChange"> & {
  /**
   * The SCM integration's ID
   *
   * @generated from field: string scm_integration_id = 1;
   */
  scmIntegrationId: string;
};

/**
 * Describes the message gitpod.v1.EventSCMIntegrationChange.
 * Use `create(EventSCMIntegrationChangeSchema)` to create a new message.
 */
export const EventSCMIntegrationChangeSchema: GenMessage<EventSCMIntegrationChange> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 28);

/**
 * @generated from message gitpod.v1.EventLLMIntegrationChange
 */
export type EventLLMIntegrationChange = Message<"gitpod.v1.EventLLMIntegrationChange"> & {
  /**
   * The LLM integration's ID
   *
   * @generated from field: string llm_integration_id = 1;
   */
  llmIntegrationId: string;
};

/**
 * Describes the message gitpod.v1.EventLLMIntegrationChange.
 * Use `create(EventLLMIntegrationChangeSchema)` to create a new message.
 */
export const EventLLMIntegrationChangeSchema: GenMessage<EventLLMIntegrationChange> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 29);

/**
 * @generated from message gitpod.v1.EventIntegrationChange
 */
export type EventIntegrationChange = Message<"gitpod.v1.EventIntegrationChange"> & {
  /**
   * The integration's ID
   *
   * @generated from field: string integration_id = 1;
   */
  integrationId: string;
};

/**
 * Describes the message gitpod.v1.EventIntegrationChange.
 * Use `create(EventIntegrationChangeSchema)` to create a new message.
 */
export const EventIntegrationChangeSchema: GenMessage<EventIntegrationChange> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 30);

/**
 * @generated from message gitpod.v1.EventSnapshotSpecChange
 */
export type EventSnapshotSpecChange = Message<"gitpod.v1.EventSnapshotSpecChange"> & {
  /**
   * The snapshot's ID
   *
   * @generated from field: string snapshot_id = 1;
   */
  snapshotId: string;
};

/**
 * Describes the message gitpod.v1.EventSnapshotSpecChange.
 * Use `create(EventSnapshotSpecChangeSchema)` to create a new message.
 */
export const EventSnapshotSpecChangeSchema: GenMessage<EventSnapshotSpecChange> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 31);

/**
 * @generated from message gitpod.v1.EventWarmPoolSpecChange
 */
export type EventWarmPoolSpecChange = Message<"gitpod.v1.EventWarmPoolSpecChange"> & {
  /**
   * The warm pool's ID
   *
   * @generated from field: string warm_pool_id = 1;
   */
  warmPoolId: string;
};

/**
 * Describes the message gitpod.v1.EventWarmPoolSpecChange.
 * Use `create(EventWarmPoolSpecChangeSchema)` to create a new message.
 */
export const EventWarmPoolSpecChangeSchema: GenMessage<EventWarmPoolSpecChange> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 32);

/**
 * @generated from message gitpod.v1.EventHostAuthenticationTokenDeleted
 */
export type EventHostAuthenticationTokenDeleted = Message<"gitpod.v1.EventHostAuthenticationTokenDeleted"> & {
  /**
   * The host authentication token's host.
   *
   * @generated from field: string host = 1;
   */
  host: string;

  /**
   * The principal ID of the deleted token.
   *
   * @generated from field: string principal_id = 2;
   */
  principalId: string;
};

/**
 * Describes the message gitpod.v1.EventHostAuthenticationTokenDeleted.
 * Use `create(EventHostAuthenticationTokenDeletedSchema)` to create a new message.
 */
export const EventHostAuthenticationTokenDeletedSchema: GenMessage<EventHostAuthenticationTokenDeleted> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 33);

/**
 * @generated from message gitpod.v1.EventAgentExecutionSpecChange
 */
export type EventAgentExecutionSpecChange = Message<"gitpod.v1.EventAgentExecutionSpecChange"> & {
  /**
   * The agent execution's ID
   *
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId: string;
};

/**
 * Describes the message gitpod.v1.EventAgentExecutionSpecChange.
 * Use `create(EventAgentExecutionSpecChangeSchema)` to create a new message.
 */
export const EventAgentExecutionSpecChangeSchema: GenMessage<EventAgentExecutionSpecChange> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 34);

/**
 * @generated from message gitpod.v1.EventRunnerConfigurationChange
 */
export type EventRunnerConfigurationChange = Message<"gitpod.v1.EventRunnerConfigurationChange"> & {
};

/**
 * Describes the message gitpod.v1.EventRunnerConfigurationChange.
 * Use `create(EventRunnerConfigurationChangeSchema)` to create a new message.
 */
export const EventRunnerConfigurationChangeSchema: GenMessage<EventRunnerConfigurationChange> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 35);

/**
 * @generated from message gitpod.v1.CallParseContext
 */
export type CallParseContext = Message<"gitpod.v1.CallParseContext"> & {
};

/**
 * Describes the message gitpod.v1.CallParseContext.
 * Use `create(CallParseContextSchema)` to create a new message.
 */
export const CallParseContextSchema: GenMessage<CallParseContext> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 36);

/**
 * @generated from message gitpod.v1.CallParseContext.Request
 */
export type CallParseContext_Request = Message<"gitpod.v1.CallParseContext.Request"> & {
  /**
   * @generated from field: string context_url = 1;
   */
  contextUrl: string;

  /**
   * @generated from field: string principal_id = 2;
   */
  principalId: string;
};

/**
 * Describes the message gitpod.v1.CallParseContext.Request.
 * Use `create(CallParseContext_RequestSchema)` to create a new message.
 */
export const CallParseContext_RequestSchema: GenMessage<CallParseContext_Request> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 36, 0);

/**
 * @generated from message gitpod.v1.CallParseContext.Response
 */
export type CallParseContext_Response = Message<"gitpod.v1.CallParseContext.Response"> & {
  /**
   * @generated from field: gitpod.v1.ParseContextURLResponse resp = 1;
   */
  resp?: ParseContextURLResponse;
};

/**
 * Describes the message gitpod.v1.CallParseContext.Response.
 * Use `create(CallParseContext_ResponseSchema)` to create a new message.
 */
export const CallParseContext_ResponseSchema: GenMessage<CallParseContext_Response> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 36, 1);

/**
 * @generated from message gitpod.v1.CallPing
 */
export type CallPing = Message<"gitpod.v1.CallPing"> & {
};

/**
 * Describes the message gitpod.v1.CallPing.
 * Use `create(CallPingSchema)` to create a new message.
 */
export const CallPingSchema: GenMessage<CallPing> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 37);

/**
 * @generated from message gitpod.v1.CallPing.Request
 */
export type CallPing_Request = Message<"gitpod.v1.CallPing.Request"> & {
};

/**
 * Describes the message gitpod.v1.CallPing.Request.
 * Use `create(CallPing_RequestSchema)` to create a new message.
 */
export const CallPing_RequestSchema: GenMessage<CallPing_Request> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 37, 0);

/**
 * @generated from message gitpod.v1.CallPing.Response
 */
export type CallPing_Response = Message<"gitpod.v1.CallPing.Response"> & {
};

/**
 * Describes the message gitpod.v1.CallPing.Response.
 * Use `create(CallPing_ResponseSchema)` to create a new message.
 */
export const CallPing_ResponseSchema: GenMessage<CallPing_Response> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 37, 1);

/**
 * @generated from message gitpod.v1.CallCheckAuthenticationForHost
 */
export type CallCheckAuthenticationForHost = Message<"gitpod.v1.CallCheckAuthenticationForHost"> & {
};

/**
 * Describes the message gitpod.v1.CallCheckAuthenticationForHost.
 * Use `create(CallCheckAuthenticationForHostSchema)` to create a new message.
 */
export const CallCheckAuthenticationForHostSchema: GenMessage<CallCheckAuthenticationForHost> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 38);

/**
 * @generated from message gitpod.v1.CallCheckAuthenticationForHost.Request
 */
export type CallCheckAuthenticationForHost_Request = Message<"gitpod.v1.CallCheckAuthenticationForHost.Request"> & {
  /**
   * @generated from field: string host = 1;
   */
  host: string;

  /**
   * @generated from field: string principal_id = 2;
   */
  principalId: string;
};

/**
 * Describes the message gitpod.v1.CallCheckAuthenticationForHost.Request.
 * Use `create(CallCheckAuthenticationForHost_RequestSchema)` to create a new message.
 */
export const CallCheckAuthenticationForHost_RequestSchema: GenMessage<CallCheckAuthenticationForHost_Request> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 38, 0);

/**
 * @generated from message gitpod.v1.CallCheckAuthenticationForHost.Response
 */
export type CallCheckAuthenticationForHost_Response = Message<"gitpod.v1.CallCheckAuthenticationForHost.Response"> & {
  /**
   * @generated from field: gitpod.v1.CheckAuthenticationForHostResponse resp = 1;
   */
  resp?: CheckAuthenticationForHostResponse;
};

/**
 * Describes the message gitpod.v1.CallCheckAuthenticationForHost.Response.
 * Use `create(CallCheckAuthenticationForHost_ResponseSchema)` to create a new message.
 */
export const CallCheckAuthenticationForHost_ResponseSchema: GenMessage<CallCheckAuthenticationForHost_Response> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 38, 1);

/**
 * @generated from message gitpod.v1.CallCheckRepositoryAccess
 */
export type CallCheckRepositoryAccess = Message<"gitpod.v1.CallCheckRepositoryAccess"> & {
};

/**
 * Describes the message gitpod.v1.CallCheckRepositoryAccess.
 * Use `create(CallCheckRepositoryAccessSchema)` to create a new message.
 */
export const CallCheckRepositoryAccessSchema: GenMessage<CallCheckRepositoryAccess> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 39);

/**
 * @generated from message gitpod.v1.CallCheckRepositoryAccess.Request
 */
export type CallCheckRepositoryAccess_Request = Message<"gitpod.v1.CallCheckRepositoryAccess.Request"> & {
  /**
   * principal_id is the ID of the user or service account to check access for.
   *
   * @generated from field: string principal_id = 1;
   */
  principalId: string;

  /**
   * repository_url is the URL of the repository to check access for.
   *
   * @generated from field: string repository_url = 2;
   */
  repositoryUrl: string;
};

/**
 * Describes the message gitpod.v1.CallCheckRepositoryAccess.Request.
 * Use `create(CallCheckRepositoryAccess_RequestSchema)` to create a new message.
 */
export const CallCheckRepositoryAccess_RequestSchema: GenMessage<CallCheckRepositoryAccess_Request> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 39, 0);

/**
 * @generated from message gitpod.v1.CallCheckRepositoryAccess.Response
 */
export type CallCheckRepositoryAccess_Response = Message<"gitpod.v1.CallCheckRepositoryAccess.Response"> & {
  /**
   * @generated from field: gitpod.v1.CheckRepositoryAccessResponse resp = 1;
   */
  resp?: CheckRepositoryAccessResponse;
};

/**
 * Describes the message gitpod.v1.CallCheckRepositoryAccess.Response.
 * Use `create(CallCheckRepositoryAccess_ResponseSchema)` to create a new message.
 */
export const CallCheckRepositoryAccess_ResponseSchema: GenMessage<CallCheckRepositoryAccess_Response> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 39, 1);

/**
 * @generated from message gitpod.v1.CallSearchRepositories
 */
export type CallSearchRepositories = Message<"gitpod.v1.CallSearchRepositories"> & {
};

/**
 * Describes the message gitpod.v1.CallSearchRepositories.
 * Use `create(CallSearchRepositoriesSchema)` to create a new message.
 */
export const CallSearchRepositoriesSchema: GenMessage<CallSearchRepositories> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 40);

/**
 * @generated from message gitpod.v1.CallSearchRepositories.Request
 */
export type CallSearchRepositories_Request = Message<"gitpod.v1.CallSearchRepositories.Request"> & {
  /**
   * The principal's ID to search repositories for
   *
   * @generated from field: string principal_id = 1;
   */
  principalId: string;

  /**
   * Search query - interpretation depends on search_mode
   *
   * @generated from field: string search_string = 2;
   */
  searchString: string;

  /**
   * Maximum number of repositories to return.
   * Deprecated: Use pagination.page_size instead
   *
   * @generated from field: int32 limit = 3 [deprecated = true];
   * @deprecated
   */
  limit: number;

  /**
   * Pagination parameters for repository search
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 4;
   */
  pagination?: PaginationRequest;

  /**
   * The SCM's host to search repositories for
   *
   * @generated from field: string scm_host = 5;
   */
  scmHost: string;

  /**
   * Search mode determines how search_string is interpreted
   *
   * @generated from field: gitpod.v1.SearchMode search_mode = 6;
   */
  searchMode: SearchMode;
};

/**
 * Describes the message gitpod.v1.CallSearchRepositories.Request.
 * Use `create(CallSearchRepositories_RequestSchema)` to create a new message.
 */
export const CallSearchRepositories_RequestSchema: GenMessage<CallSearchRepositories_Request> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 40, 0);

/**
 * @generated from message gitpod.v1.CallSearchRepositories.Response
 */
export type CallSearchRepositories_Response = Message<"gitpod.v1.CallSearchRepositories.Response"> & {
  /**
   * List of repositories matching the search criteria
   *
   * @generated from field: repeated gitpod.v1.SearchRepositoriesResponse.Repository repositories = 1;
   */
  repositories: SearchRepositoriesResponse_Repository[];

  /**
   * Pagination information for the response.
   * Token format: "NEXT_PAGE/TOTAL_PAGES/TOTAL_COUNT" (e.g., "2/40/1000").
   * Use -1 for unknown values (e.g., "2/-1/-1" when totals unavailable).
   * Empty token means no more pages.
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;

  /**
   * Deprecated: Use pagination token instead. Total pages can be extracted from token.
   *
   * @generated from field: int32 last_page = 3;
   */
  lastPage: number;
};

/**
 * Describes the message gitpod.v1.CallSearchRepositories.Response.
 * Use `create(CallSearchRepositories_ResponseSchema)` to create a new message.
 */
export const CallSearchRepositories_ResponseSchema: GenMessage<CallSearchRepositories_Response> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 40, 1);

/**
 * @generated from message gitpod.v1.CallListSCMOrganizations
 */
export type CallListSCMOrganizations = Message<"gitpod.v1.CallListSCMOrganizations"> & {
};

/**
 * Describes the message gitpod.v1.CallListSCMOrganizations.
 * Use `create(CallListSCMOrganizationsSchema)` to create a new message.
 */
export const CallListSCMOrganizationsSchema: GenMessage<CallListSCMOrganizations> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 41);

/**
 * @generated from message gitpod.v1.CallListSCMOrganizations.Request
 */
export type CallListSCMOrganizations_Request = Message<"gitpod.v1.CallListSCMOrganizations.Request"> & {
  /**
   * The principal's ID to list organizations for
   *
   * @generated from field: string principal_id = 1;
   */
  principalId: string;

  /**
   * The SCM host to list organizations from (e.g., "github.com", "gitlab.com")
   *
   * @generated from field: string scm_host = 2;
   */
  scmHost: string;
};

/**
 * Describes the message gitpod.v1.CallListSCMOrganizations.Request.
 * Use `create(CallListSCMOrganizations_RequestSchema)` to create a new message.
 */
export const CallListSCMOrganizations_RequestSchema: GenMessage<CallListSCMOrganizations_Request> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 41, 0);

/**
 * @generated from message gitpod.v1.CallListSCMOrganizations.Response
 */
export type CallListSCMOrganizations_Response = Message<"gitpod.v1.CallListSCMOrganizations.Response"> & {
  /**
   * List of organizations the user belongs to
   *
   * @generated from field: repeated gitpod.v1.ListSCMOrganizationsResponse.SCMOrganization organizations = 1;
   */
  organizations: ListSCMOrganizationsResponse_SCMOrganization[];
};

/**
 * Describes the message gitpod.v1.CallListSCMOrganizations.Response.
 * Use `create(CallListSCMOrganizations_ResponseSchema)` to create a new message.
 */
export const CallListSCMOrganizations_ResponseSchema: GenMessage<CallListSCMOrganizations_Response> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 41, 1);

/**
 * @generated from message gitpod.v1.CallValidateConfig
 */
export type CallValidateConfig = Message<"gitpod.v1.CallValidateConfig"> & {
};

/**
 * Describes the message gitpod.v1.CallValidateConfig.
 * Use `create(CallValidateConfigSchema)` to create a new message.
 */
export const CallValidateConfigSchema: GenMessage<CallValidateConfig> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 42);

/**
 * @generated from message gitpod.v1.CallValidateConfig.Request
 */
export type CallValidateConfig_Request = Message<"gitpod.v1.CallValidateConfig.Request"> & {
  /**
   * @generated from oneof gitpod.v1.CallValidateConfig.Request.config
   */
  config: {
    /**
     * @generated from field: gitpod.v1.EnvironmentClass environment_class = 1;
     */
    value: EnvironmentClass;
    case: "environmentClass";
  } | {
    /**
     * @generated from field: gitpod.v1.SCMIntegration scm = 2;
     */
    value: SCMIntegration;
    case: "scm";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.CallValidateConfig.Request.
 * Use `create(CallValidateConfig_RequestSchema)` to create a new message.
 */
export const CallValidateConfig_RequestSchema: GenMessage<CallValidateConfig_Request> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 42, 0);

/**
 * @generated from message gitpod.v1.CallValidateConfig.Response
 */
export type CallValidateConfig_Response = Message<"gitpod.v1.CallValidateConfig.Response"> & {
  /**
   * @generated from oneof gitpod.v1.CallValidateConfig.Response.result
   */
  result: {
    /**
     * @generated from field: gitpod.v1.EnvironmentClassValidationResult environment_class = 1;
     */
    value: EnvironmentClassValidationResult;
    case: "environmentClass";
  } | {
    /**
     * @generated from field: gitpod.v1.SCMIntegrationValidationResult scm = 2;
     */
    value: SCMIntegrationValidationResult;
    case: "scm";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.CallValidateConfig.Response.
 * Use `create(CallValidateConfig_ResponseSchema)` to create a new message.
 */
export const CallValidateConfig_ResponseSchema: GenMessage<CallValidateConfig_Response> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 42, 1);

/**
 * @generated from message gitpod.v1.CallSendMessageToAgentExecution
 */
export type CallSendMessageToAgentExecution = Message<"gitpod.v1.CallSendMessageToAgentExecution"> & {
};

/**
 * Describes the message gitpod.v1.CallSendMessageToAgentExecution.
 * Use `create(CallSendMessageToAgentExecutionSchema)` to create a new message.
 */
export const CallSendMessageToAgentExecutionSchema: GenMessage<CallSendMessageToAgentExecution> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 43);

/**
 * @generated from message gitpod.v1.CallSendMessageToAgentExecution.Request
 */
export type CallSendMessageToAgentExecution_Request = Message<"gitpod.v1.CallSendMessageToAgentExecution.Request"> & {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId: string;

  /**
   * @generated from oneof gitpod.v1.CallSendMessageToAgentExecution.Request.input
   */
  input: {
    /**
     * @generated from field: gitpod.v1.UserInputBlock message = 2;
     */
    value: UserInputBlock;
    case: "message";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentMessage agent_message = 3;
     */
    value: AgentMessage;
    case: "agentMessage";
  } | {
    /**
     * @generated from field: gitpod.v1.WakeEvent wake_event = 4;
     */
    value: WakeEvent;
    case: "wakeEvent";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.CallSendMessageToAgentExecution.Request.
 * Use `create(CallSendMessageToAgentExecution_RequestSchema)` to create a new message.
 */
export const CallSendMessageToAgentExecution_RequestSchema: GenMessage<CallSendMessageToAgentExecution_Request> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 43, 0);

/**
 * @generated from message gitpod.v1.CallSendMessageToAgentExecution.Response
 */
export type CallSendMessageToAgentExecution_Response = Message<"gitpod.v1.CallSendMessageToAgentExecution.Response"> & {
};

/**
 * Describes the message gitpod.v1.CallSendMessageToAgentExecution.Response.
 * Use `create(CallSendMessageToAgentExecution_ResponseSchema)` to create a new message.
 */
export const CallSendMessageToAgentExecution_ResponseSchema: GenMessage<CallSendMessageToAgentExecution_Response> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 43, 1);

/**
 * @generated from message gitpod.v1.CallImprovePromptForAgent
 */
export type CallImprovePromptForAgent = Message<"gitpod.v1.CallImprovePromptForAgent"> & {
};

/**
 * Describes the message gitpod.v1.CallImprovePromptForAgent.
 * Use `create(CallImprovePromptForAgentSchema)` to create a new message.
 */
export const CallImprovePromptForAgentSchema: GenMessage<CallImprovePromptForAgent> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 44);

/**
 * @generated from message gitpod.v1.CallImprovePromptForAgent.Request
 */
export type CallImprovePromptForAgent_Request = Message<"gitpod.v1.CallImprovePromptForAgent.Request"> & {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId: string;

  /**
   * @generated from field: string prompt = 2;
   */
  prompt: string;
};

/**
 * Describes the message gitpod.v1.CallImprovePromptForAgent.Request.
 * Use `create(CallImprovePromptForAgent_RequestSchema)` to create a new message.
 */
export const CallImprovePromptForAgent_RequestSchema: GenMessage<CallImprovePromptForAgent_Request> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 44, 0);

/**
 * @generated from message gitpod.v1.CallImprovePromptForAgent.Response
 */
export type CallImprovePromptForAgent_Response = Message<"gitpod.v1.CallImprovePromptForAgent.Response"> & {
  /**
   * @generated from field: string improved_prompt = 1;
   */
  improvedPrompt: string;
};

/**
 * Describes the message gitpod.v1.CallImprovePromptForAgent.Response.
 * Use `create(CallImprovePromptForAgent_ResponseSchema)` to create a new message.
 */
export const CallImprovePromptForAgent_ResponseSchema: GenMessage<CallImprovePromptForAgent_Response> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 44, 1);

/**
 * @generated from message gitpod.v1.GetLatestVersionRequest
 */
export type GetLatestVersionRequest = Message<"gitpod.v1.GetLatestVersionRequest"> & {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * The current version of the runner
   *
   * @generated from field: string current_version = 2;
   */
  currentVersion: string;

  /**
   * The version of the infrastructure
   *
   * @generated from field: string infrastructure_version = 3;
   */
  infrastructureVersion: string;
};

/**
 * Describes the message gitpod.v1.GetLatestVersionRequest.
 * Use `create(GetLatestVersionRequestSchema)` to create a new message.
 */
export const GetLatestVersionRequestSchema: GenMessage<GetLatestVersionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 45);

/**
 * @generated from message gitpod.v1.GetLatestVersionResponse
 */
export type GetLatestVersionResponse = Message<"gitpod.v1.GetLatestVersionResponse"> & {
  /**
   * The latest version of the runner
   *
   * @generated from field: string version = 1;
   */
  version: string;

  /**
   * deprecated: aws-specific field, use manifest.aws_ec2.runner_image instead
   *
   * @generated from field: string runner_image = 2;
   */
  runnerImage: string;

  /**
   * auto-update indicates if the runner should be updated automatically
   *
   * @generated from field: bool auto_update = 3;
   */
  autoUpdate: boolean;

  /**
   * supervisor_download_url is the URL to download the supervisor
   *
   * @generated from field: string supervisor_download_url = 4;
   */
  supervisorDownloadUrl: string;

  /**
   * gitpod_cli_download_url is the URL to download the gitpod CLI
   *
   * @generated from field: string gitpod_cli_download_url = 5;
   */
  gitpodCliDownloadUrl: string;

  /**
   * hotfix indicates this release should bypass update windows and be applied immediately.
   *
   * @generated from field: bool hotfix = 6;
   */
  hotfix: boolean;

  /**
   * one of based on runner provider
   *
   * @generated from oneof gitpod.v1.GetLatestVersionResponse.manifest
   */
  manifest: {
    /**
     * @generated from field: gitpod.v1.GetLatestVersionResponse.AwsEc2Manifest aws_ec2 = 10;
     */
    value: GetLatestVersionResponse_AwsEc2Manifest;
    case: "awsEc2";
  } | {
    /**
     * @generated from field: gitpod.v1.GetLatestVersionResponse.LinuxHostManifest linux_host = 20;
     */
    value: GetLatestVersionResponse_LinuxHostManifest;
    case: "linuxHost";
  } | {
    /**
     * @generated from field: gitpod.v1.GetLatestVersionResponse.GcpManifest gcp = 30;
     */
    value: GetLatestVersionResponse_GcpManifest;
    case: "gcp";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.GetLatestVersionResponse.
 * Use `create(GetLatestVersionResponseSchema)` to create a new message.
 */
export const GetLatestVersionResponseSchema: GenMessage<GetLatestVersionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 46);

/**
 * @generated from message gitpod.v1.GetLatestVersionResponse.AwsEc2Manifest
 */
export type GetLatestVersionResponse_AwsEc2Manifest = Message<"gitpod.v1.GetLatestVersionResponse.AwsEc2Manifest"> & {
  /**
   * The container image of the runner.
   * Will only be set if the latest release in the release channel has the same infrastructure version as the runner.
   *
   * @generated from field: string runner_image = 1;
   */
  runnerImage: string;

  /**
   * The container image of the proxy.
   * Will only be set if the latest release in the release channel has the same infrastructure version as the runner.
   *
   * @generated from field: string proxy_image = 2;
   */
  proxyImage: string;

  /**
   * Deprecated: AMI image maps are no longer sent to runners.
   *
   * @generated from field: map<string, string> ami_image_map = 3 [deprecated = true];
   * @deprecated
   */
  amiImageMap: { [key: string]: string };
};

/**
 * Describes the message gitpod.v1.GetLatestVersionResponse.AwsEc2Manifest.
 * Use `create(GetLatestVersionResponse_AwsEc2ManifestSchema)` to create a new message.
 */
export const GetLatestVersionResponse_AwsEc2ManifestSchema: GenMessage<GetLatestVersionResponse_AwsEc2Manifest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 46, 0);

/**
 * @generated from message gitpod.v1.GetLatestVersionResponse.LinuxHostManifest
 */
export type GetLatestVersionResponse_LinuxHostManifest = Message<"gitpod.v1.GetLatestVersionResponse.LinuxHostManifest"> & {
  /**
   * @generated from field: string linux_runner_url = 1;
   */
  linuxRunnerUrl: string;

  /**
   * @generated from field: string kernel_image_url = 2;
   */
  kernelImageUrl: string;

  /**
   * @generated from field: string rootfs_disk_image_url = 3;
   */
  rootfsDiskImageUrl: string;

  /**
   * @generated from field: string shared_disk_image_url = 4;
   */
  sharedDiskImageUrl: string;

  /**
   * @generated from field: string cloud_hypervisor_url = 5;
   */
  cloudHypervisorUrl: string;

  /**
   * @generated from field: string ch_remote_static_url = 6;
   */
  chRemoteStaticUrl: string;

  /**
   * @generated from field: string zstd_url = 7;
   */
  zstdUrl: string;
};

/**
 * Describes the message gitpod.v1.GetLatestVersionResponse.LinuxHostManifest.
 * Use `create(GetLatestVersionResponse_LinuxHostManifestSchema)` to create a new message.
 */
export const GetLatestVersionResponse_LinuxHostManifestSchema: GenMessage<GetLatestVersionResponse_LinuxHostManifest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 46, 1);

/**
 * @generated from message gitpod.v1.GetLatestVersionResponse.GcpManifest
 */
export type GetLatestVersionResponse_GcpManifest = Message<"gitpod.v1.GetLatestVersionResponse.GcpManifest"> & {
  /**
   * The container image of the runner.
   * Will only be set if the latest release in the release channel has the same infrastructure version as the runner.
   *
   * @generated from field: string runner_image = 1;
   */
  runnerImage: string;

  /**
   * The container image of the proxy.
   * Will only be set if the latest release in the release channel has the same infrastructure version as the runner.
   *
   * @generated from field: string proxy_image = 2;
   */
  proxyImage: string;

  /**
   * Terraform files to be used to create the runner.
   *
   * @generated from field: repeated string terraform_files = 3;
   */
  terraformFiles: string[];

  /**
   * Download URL for the terraform files.
   *
   * @generated from field: string download_url = 4;
   */
  downloadUrl: string;
};

/**
 * Describes the message gitpod.v1.GetLatestVersionResponse.GcpManifest.
 * Use `create(GetLatestVersionResponse_GcpManifestSchema)` to create a new message.
 */
export const GetLatestVersionResponse_GcpManifestSchema: GenMessage<GetLatestVersionResponse_GcpManifest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 46, 2);

/**
 * @generated from message gitpod.v1.GetRunnerConfigurationRequest
 */
export type GetRunnerConfigurationRequest = Message<"gitpod.v1.GetRunnerConfigurationRequest"> & {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;
};

/**
 * Describes the message gitpod.v1.GetRunnerConfigurationRequest.
 * Use `create(GetRunnerConfigurationRequestSchema)` to create a new message.
 */
export const GetRunnerConfigurationRequestSchema: GenMessage<GetRunnerConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 47);

/**
 * @generated from message gitpod.v1.RunnerMetricsConfiguration
 */
export type RunnerMetricsConfiguration = Message<"gitpod.v1.RunnerMetricsConfiguration"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: bytes encrypted_username = 3;
   */
  encryptedUsername: Uint8Array;

  /**
   * @generated from field: bytes encrypted_password = 4;
   */
  encryptedPassword: Uint8Array;

  /**
   * When true, the runner pushes metrics to the management plane via
   * ReportRunnerMetrics instead of directly to the remote_write endpoint.
   *
   * @generated from field: bool managed_metrics_enabled = 5;
   */
  managedMetricsEnabled: boolean;

  /**
   * When true, the runner also forwards verbose
   * metrics (e.g. aws_sdk_go_*) via the managed metrics pipeline.
   * Disabled by default to control metrics volume.
   *
   * @generated from field: bool include_verbose_metrics = 6;
   */
  includeVerboseMetrics: boolean;
};

/**
 * Describes the message gitpod.v1.RunnerMetricsConfiguration.
 * Use `create(RunnerMetricsConfigurationSchema)` to create a new message.
 */
export const RunnerMetricsConfigurationSchema: GenMessage<RunnerMetricsConfiguration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 48);

/**
 * @generated from message gitpod.v1.GetRunnerConfigurationResponse
 */
export type GetRunnerConfigurationResponse = Message<"gitpod.v1.GetRunnerConfigurationResponse"> & {
  /**
   * @generated from field: gitpod.v1.GetRunnerConfigurationResponse.RunnerConfiguration configuration = 1;
   */
  configuration?: GetRunnerConfigurationResponse_RunnerConfiguration;
};

/**
 * Describes the message gitpod.v1.GetRunnerConfigurationResponse.
 * Use `create(GetRunnerConfigurationResponseSchema)` to create a new message.
 */
export const GetRunnerConfigurationResponseSchema: GenMessage<GetRunnerConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 49);

/**
 * @generated from message gitpod.v1.GetRunnerConfigurationResponse.RunnerConfiguration
 */
export type GetRunnerConfigurationResponse_RunnerConfiguration = Message<"gitpod.v1.GetRunnerConfigurationResponse.RunnerConfiguration"> & {
  /**
   * @generated from field: string region = 1;
   */
  region: string;

  /**
   * @generated from field: gitpod.v1.RunnerReleaseChannel release_channel = 2;
   */
  releaseChannel: RunnerReleaseChannel;

  /**
   * @generated from field: bool auto_update = 3;
   */
  autoUpdate: boolean;

  /**
   * @generated from field: gitpod.v1.RunnerMetricsConfiguration metrics = 4;
   */
  metrics?: RunnerMetricsConfiguration;

  /**
   * @generated from field: gitpod.v1.LogLevel log_level = 5;
   */
  logLevel: LogLevel;

  /**
   * @generated from field: bool devcontainer_image_cache_enabled = 6;
   */
  devcontainerImageCacheEnabled: boolean;

  /**
   * update_window defines the daily time window (UTC) during which auto-updates are allowed.
   * If not set, updates are allowed at any time.
   *
   * @generated from field: gitpod.v1.UpdateWindow update_window = 7;
   */
  updateWindow?: UpdateWindow;

  /**
   * encrypted_honeycomb_api_key is the Honeycomb API key encrypted with the runner's public key.
   *
   * @generated from field: bytes encrypted_honeycomb_api_key = 8;
   */
  encryptedHoneycombApiKey: Uint8Array;

  /**
   * continuous_profiling indicates whether continuous profiling is enabled.
   *
   * @generated from field: bool continuous_profiling = 9;
   */
  continuousProfiling: boolean;
};

/**
 * Describes the message gitpod.v1.GetRunnerConfigurationResponse.RunnerConfiguration.
 * Use `create(GetRunnerConfigurationResponse_RunnerConfigurationSchema)` to create a new message.
 */
export const GetRunnerConfigurationResponse_RunnerConfigurationSchema: GenMessage<GetRunnerConfigurationResponse_RunnerConfiguration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 49, 0);

/**
 * @generated from message gitpod.v1.ListRunnerAgentExecutionsRequest
 */
export type ListRunnerAgentExecutionsRequest = Message<"gitpod.v1.ListRunnerAgentExecutionsRequest"> & {
  /**
   * pagination contains the pagination options for listing agent executions
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: string runner_id = 2;
   */
  runnerId: string;

  /**
   * @generated from field: gitpod.v1.ListRunnerAgentExecutionsRequest.Filter filter = 3;
   */
  filter?: ListRunnerAgentExecutionsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListRunnerAgentExecutionsRequest.
 * Use `create(ListRunnerAgentExecutionsRequestSchema)` to create a new message.
 */
export const ListRunnerAgentExecutionsRequestSchema: GenMessage<ListRunnerAgentExecutionsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 50);

/**
 * @generated from message gitpod.v1.ListRunnerAgentExecutionsRequest.Filter
 */
export type ListRunnerAgentExecutionsRequest_Filter = Message<"gitpod.v1.ListRunnerAgentExecutionsRequest.Filter"> & {
  /**
   * When true, only return agent executions that require processing.
   * Excludes executions where phase is terminal (stopped/waiting_for_input)
   * and spec.session matches status.session (no new user input).
   *
   * @generated from field: bool active_only = 1;
   */
  activeOnly: boolean;

  /**
   * When set, only return agent executions matching these IDs.
   *
   * @generated from field: repeated string agent_execution_ids = 2;
   */
  agentExecutionIds: string[];

  /**
   * When true, return only execution IDs without full content
   * (no spec, status, metadata, or access token).
   *
   * @generated from field: bool ids_only = 3;
   */
  idsOnly: boolean;
};

/**
 * Describes the message gitpod.v1.ListRunnerAgentExecutionsRequest.Filter.
 * Use `create(ListRunnerAgentExecutionsRequest_FilterSchema)` to create a new message.
 */
export const ListRunnerAgentExecutionsRequest_FilterSchema: GenMessage<ListRunnerAgentExecutionsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 50, 0);

/**
 * @generated from message gitpod.v1.RunnerAgentExecution
 */
export type RunnerAgentExecution = Message<"gitpod.v1.RunnerAgentExecution"> & {
  /**
   * @generated from field: gitpod.v1.AgentExecution agent_execution = 1;
   */
  agentExecution?: AgentExecution;

  /**
   * @generated from field: string actor_access_token = 3;
   */
  actorAccessToken: string;
};

/**
 * Describes the message gitpod.v1.RunnerAgentExecution.
 * Use `create(RunnerAgentExecutionSchema)` to create a new message.
 */
export const RunnerAgentExecutionSchema: GenMessage<RunnerAgentExecution> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 51);

/**
 * @generated from message gitpod.v1.ListRunnerAgentExecutionsResponse
 */
export type ListRunnerAgentExecutionsResponse = Message<"gitpod.v1.ListRunnerAgentExecutionsResponse"> & {
  /**
   * pagination contains the pagination options for listing agent executions
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The agent ListRunnerAgentExecutionsRequest on the runner
   *
   * @generated from field: repeated gitpod.v1.RunnerAgentExecution agent_executions = 2;
   */
  agentExecutions: RunnerAgentExecution[];
};

/**
 * Describes the message gitpod.v1.ListRunnerAgentExecutionsResponse.
 * Use `create(ListRunnerAgentExecutionsResponseSchema)` to create a new message.
 */
export const ListRunnerAgentExecutionsResponseSchema: GenMessage<ListRunnerAgentExecutionsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 52);

/**
 * @generated from message gitpod.v1.GetRunnerAgentExecutionRequest
 */
export type GetRunnerAgentExecutionRequest = Message<"gitpod.v1.GetRunnerAgentExecutionRequest"> & {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * @generated from field: string agent_execution_id = 2;
   */
  agentExecutionId: string;
};

/**
 * Describes the message gitpod.v1.GetRunnerAgentExecutionRequest.
 * Use `create(GetRunnerAgentExecutionRequestSchema)` to create a new message.
 */
export const GetRunnerAgentExecutionRequestSchema: GenMessage<GetRunnerAgentExecutionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 53);

/**
 * @generated from message gitpod.v1.GetRunnerAgentExecutionResponse
 */
export type GetRunnerAgentExecutionResponse = Message<"gitpod.v1.GetRunnerAgentExecutionResponse"> & {
  /**
   * @generated from field: gitpod.v1.RunnerAgentExecution agent_execution = 1;
   */
  agentExecution?: RunnerAgentExecution;
};

/**
 * Describes the message gitpod.v1.GetRunnerAgentExecutionResponse.
 * Use `create(GetRunnerAgentExecutionResponseSchema)` to create a new message.
 */
export const GetRunnerAgentExecutionResponseSchema: GenMessage<GetRunnerAgentExecutionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 54);

/**
 * @generated from message gitpod.v1.UpdateRunnerAgentExecutionRequest
 */
export type UpdateRunnerAgentExecutionRequest = Message<"gitpod.v1.UpdateRunnerAgentExecutionRequest"> & {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * @generated from field: string agent_execution_id = 2;
   */
  agentExecutionId: string;

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string;

  /**
   * @generated from field: gitpod.v1.AgentExecution.Status status = 5;
   */
  status?: AgentExecution_Status;
};

/**
 * Describes the message gitpod.v1.UpdateRunnerAgentExecutionRequest.
 * Use `create(UpdateRunnerAgentExecutionRequestSchema)` to create a new message.
 */
export const UpdateRunnerAgentExecutionRequestSchema: GenMessage<UpdateRunnerAgentExecutionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 55);

/**
 * @generated from message gitpod.v1.UpdateRunnerAgentExecutionResponse
 */
export type UpdateRunnerAgentExecutionResponse = Message<"gitpod.v1.UpdateRunnerAgentExecutionResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateRunnerAgentExecutionResponse.
 * Use `create(UpdateRunnerAgentExecutionResponseSchema)` to create a new message.
 */
export const UpdateRunnerAgentExecutionResponseSchema: GenMessage<UpdateRunnerAgentExecutionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 56);

/**
 * @generated from message gitpod.v1.GetRunnerLLMIntegrationRequest
 */
export type GetRunnerLLMIntegrationRequest = Message<"gitpod.v1.GetRunnerLLMIntegrationRequest"> & {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * The LLM integration's ID
   *
   * @generated from field: string llm_integration_id = 2;
   */
  llmIntegrationId: string;
};

/**
 * Describes the message gitpod.v1.GetRunnerLLMIntegrationRequest.
 * Use `create(GetRunnerLLMIntegrationRequestSchema)` to create a new message.
 */
export const GetRunnerLLMIntegrationRequestSchema: GenMessage<GetRunnerLLMIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 57);

/**
 * @generated from message gitpod.v1.GetRunnerLLMIntegrationResponse
 */
export type GetRunnerLLMIntegrationResponse = Message<"gitpod.v1.GetRunnerLLMIntegrationResponse"> & {
  /**
   * @generated from field: gitpod.v1.LLMIntegration llm_integration = 1;
   */
  llmIntegration?: LLMIntegration;
};

/**
 * Describes the message gitpod.v1.GetRunnerLLMIntegrationResponse.
 * Use `create(GetRunnerLLMIntegrationResponseSchema)` to create a new message.
 */
export const GetRunnerLLMIntegrationResponseSchema: GenMessage<GetRunnerLLMIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 58);

/**
 * @generated from message gitpod.v1.ListRunnerLLMIntegrationsRequest
 */
export type ListRunnerLLMIntegrationsRequest = Message<"gitpod.v1.ListRunnerLLMIntegrationsRequest"> & {
  /**
   * pagination contains the pagination options for listing LLM integrations
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId: string;

  /**
   * @generated from field: gitpod.v1.ListRunnerLLMIntegrationsRequest.Filter filter = 3;
   */
  filter?: ListRunnerLLMIntegrationsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListRunnerLLMIntegrationsRequest.
 * Use `create(ListRunnerLLMIntegrationsRequestSchema)` to create a new message.
 */
export const ListRunnerLLMIntegrationsRequestSchema: GenMessage<ListRunnerLLMIntegrationsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 59);

/**
 * @generated from message gitpod.v1.ListRunnerLLMIntegrationsRequest.Filter
 */
export type ListRunnerLLMIntegrationsRequest_Filter = Message<"gitpod.v1.ListRunnerLLMIntegrationsRequest.Filter"> & {
  /**
   * supported_models filters the response to only LLM integrations with these models
   *
   * @generated from field: repeated gitpod.v1.SupportedModel supported_models = 1;
   */
  supportedModels: SupportedModel[];
};

/**
 * Describes the message gitpod.v1.ListRunnerLLMIntegrationsRequest.Filter.
 * Use `create(ListRunnerLLMIntegrationsRequest_FilterSchema)` to create a new message.
 */
export const ListRunnerLLMIntegrationsRequest_FilterSchema: GenMessage<ListRunnerLLMIntegrationsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 59, 0);

/**
 * @generated from message gitpod.v1.ListRunnerLLMIntegrationsResponse
 */
export type ListRunnerLLMIntegrationsResponse = Message<"gitpod.v1.ListRunnerLLMIntegrationsResponse"> & {
  /**
   * pagination contains the pagination options for listing LLM integrations
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The LLM integrations configured for the runner
   *
   * @generated from field: repeated gitpod.v1.LLMIntegration llm_integrations = 2;
   */
  llmIntegrations: LLMIntegration[];
};

/**
 * Describes the message gitpod.v1.ListRunnerLLMIntegrationsResponse.
 * Use `create(ListRunnerLLMIntegrationsResponseSchema)` to create a new message.
 */
export const ListRunnerLLMIntegrationsResponseSchema: GenMessage<ListRunnerLLMIntegrationsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 60);

/**
 * @generated from message gitpod.v1.ListRunnerIntegrationsRequest
 */
export type ListRunnerIntegrationsRequest = Message<"gitpod.v1.ListRunnerIntegrationsRequest"> & {
  /**
   * pagination contains the pagination options for listing integrations
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId: string;

  /**
   * @generated from field: gitpod.v1.ListRunnerIntegrationsRequest.Filter filter = 3;
   */
  filter?: ListRunnerIntegrationsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListRunnerIntegrationsRequest.
 * Use `create(ListRunnerIntegrationsRequestSchema)` to create a new message.
 */
export const ListRunnerIntegrationsRequestSchema: GenMessage<ListRunnerIntegrationsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 61);

/**
 * @generated from message gitpod.v1.ListRunnerIntegrationsRequest.Filter
 */
export type ListRunnerIntegrationsRequest_Filter = Message<"gitpod.v1.ListRunnerIntegrationsRequest.Filter"> & {
  /**
   * integration_ids filters the response to only integrations with these IDs
   *
   * @generated from field: repeated string integration_ids = 1;
   */
  integrationIds: string[];
};

/**
 * Describes the message gitpod.v1.ListRunnerIntegrationsRequest.Filter.
 * Use `create(ListRunnerIntegrationsRequest_FilterSchema)` to create a new message.
 */
export const ListRunnerIntegrationsRequest_FilterSchema: GenMessage<ListRunnerIntegrationsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 61, 0);

/**
 * @generated from message gitpod.v1.ListRunnerIntegrationsResponse
 */
export type ListRunnerIntegrationsResponse = Message<"gitpod.v1.ListRunnerIntegrationsResponse"> & {
  /**
   * pagination contains the pagination options for listing integrations
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The integrations configured for the runner
   *
   * @generated from field: repeated gitpod.v1.Integration integrations = 2;
   */
  integrations: Integration[];
};

/**
 * Describes the message gitpod.v1.ListRunnerIntegrationsResponse.
 * Use `create(ListRunnerIntegrationsResponseSchema)` to create a new message.
 */
export const ListRunnerIntegrationsResponseSchema: GenMessage<ListRunnerIntegrationsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 62);

/**
 * @generated from message gitpod.v1.ListManagedRunnersRequest
 */
export type ListManagedRunnersRequest = Message<"gitpod.v1.ListManagedRunnersRequest"> & {
  /**
   * pagination contains the pagination options for listing managed runners
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1 [deprecated = true];
   * @deprecated
   */
  pagination?: PaginationRequest;

  /**
   * pagination contains the pagination options for listing managed runners (allowing up to 10000 per page)
   *
   * @generated from field: gitpod.v1.BigPaginationRequest big_pagination = 2;
   */
  bigPagination?: BigPaginationRequest;
};

/**
 * Describes the message gitpod.v1.ListManagedRunnersRequest.
 * Use `create(ListManagedRunnersRequestSchema)` to create a new message.
 */
export const ListManagedRunnersRequestSchema: GenMessage<ListManagedRunnersRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 63);

/**
 * @generated from message gitpod.v1.ListManagedRunnersResponse
 */
export type ListManagedRunnersResponse = Message<"gitpod.v1.ListManagedRunnersResponse"> & {
  /**
   * pagination contains the pagination options for listing managed runners
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The managed runners
   *
   * @generated from field: repeated gitpod.v1.ManagedRunner runners = 2;
   */
  runners: ManagedRunner[];
};

/**
 * Describes the message gitpod.v1.ListManagedRunnersResponse.
 * Use `create(ListManagedRunnersResponseSchema)` to create a new message.
 */
export const ListManagedRunnersResponseSchema: GenMessage<ListManagedRunnersResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 64);

/**
 * @generated from message gitpod.v1.GetManagedRunnerRequest
 */
export type GetManagedRunnerRequest = Message<"gitpod.v1.GetManagedRunnerRequest"> & {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;
};

/**
 * Describes the message gitpod.v1.GetManagedRunnerRequest.
 * Use `create(GetManagedRunnerRequestSchema)` to create a new message.
 */
export const GetManagedRunnerRequestSchema: GenMessage<GetManagedRunnerRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 65);

/**
 * @generated from message gitpod.v1.GetManagedRunnerResponse
 */
export type GetManagedRunnerResponse = Message<"gitpod.v1.GetManagedRunnerResponse"> & {
  /**
   * @generated from field: gitpod.v1.ManagedRunner runner = 1;
   */
  runner?: ManagedRunner;
};

/**
 * Describes the message gitpod.v1.GetManagedRunnerResponse.
 * Use `create(GetManagedRunnerResponseSchema)` to create a new message.
 */
export const GetManagedRunnerResponseSchema: GenMessage<GetManagedRunnerResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 66);

/**
 * @generated from message gitpod.v1.ManagedRunner
 */
export type ManagedRunner = Message<"gitpod.v1.ManagedRunner"> & {
  /**
   * The runner's ID
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * The organization's ID that this runner is assigned to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.ManagedRunner.
 * Use `create(ManagedRunnerSchema)` to create a new message.
 */
export const ManagedRunnerSchema: GenMessage<ManagedRunner> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 67);

/**
 * @generated from message gitpod.v1.WatchManagedRunnersRequest
 */
export type WatchManagedRunnersRequest = Message<"gitpod.v1.WatchManagedRunnersRequest"> & {
};

/**
 * Describes the message gitpod.v1.WatchManagedRunnersRequest.
 * Use `create(WatchManagedRunnersRequestSchema)` to create a new message.
 */
export const WatchManagedRunnersRequestSchema: GenMessage<WatchManagedRunnersRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 68);

/**
 * @generated from message gitpod.v1.WatchManagedRunnersResponse
 */
export type WatchManagedRunnersResponse = Message<"gitpod.v1.WatchManagedRunnersResponse"> & {
  /**
   * The runner's ID
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * The type of event that occurred
   *
   * @generated from field: gitpod.v1.WatchManagedRunnersResponse.EventType event_type = 2;
   */
  eventType: WatchManagedRunnersResponse_EventType;
};

/**
 * Describes the message gitpod.v1.WatchManagedRunnersResponse.
 * Use `create(WatchManagedRunnersResponseSchema)` to create a new message.
 */
export const WatchManagedRunnersResponseSchema: GenMessage<WatchManagedRunnersResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 69);

/**
 * @generated from enum gitpod.v1.WatchManagedRunnersResponse.EventType
 */
export enum WatchManagedRunnersResponse_EventType {
  /**
   * @generated from enum value: EVENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EVENT_TYPE_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: EVENT_TYPE_DELETED = 2;
   */
  DELETED = 2,

  /**
   * @generated from enum value: EVENT_TYPE_HIBERNATED = 3;
   */
  HIBERNATED = 3,

  /**
   * @generated from enum value: EVENT_TYPE_WAKE = 4;
   */
  WAKE = 4,
}

/**
 * Describes the enum gitpod.v1.WatchManagedRunnersResponse.EventType.
 */
export const WatchManagedRunnersResponse_EventTypeSchema: GenEnum<WatchManagedRunnersResponse_EventType> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_runner_interaction, 69, 0);

/**
 * @generated from message gitpod.v1.ReportLLMUsageRequest
 */
export type ReportLLMUsageRequest = Message<"gitpod.v1.ReportLLMUsageRequest"> & {
  /**
   * Idempotency key to prevent duplicate usage reports
   *
   * @generated from field: string idempotency_key = 1;
   */
  idempotencyKey: string;

  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId: string;

  /**
   * The model used for the LLM request
   *
   * @generated from field: gitpod.v1.SupportedModel supported_model = 3;
   */
  supportedModel: SupportedModel;

  /**
   * The LLM integration's ID
   *
   * @generated from field: string llm_integration_id = 4;
   */
  llmIntegrationId: string;

  /**
   * The agent execution ID if this usage is associated with an agent execution
   *
   * @generated from field: string agent_execution_id = 9;
   */
  agentExecutionId: string;

  /**
   * @generated from field: gitpod.v1.LLMUsage usage = 10;
   */
  usage?: LLMUsage;
};

/**
 * Describes the message gitpod.v1.ReportLLMUsageRequest.
 * Use `create(ReportLLMUsageRequestSchema)` to create a new message.
 */
export const ReportLLMUsageRequestSchema: GenMessage<ReportLLMUsageRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 70);

/**
 * @generated from message gitpod.v1.LLMUsage
 */
export type LLMUsage = Message<"gitpod.v1.LLMUsage"> & {
  /**
   * Number of input tokens consumed
   *
   * @generated from field: uint64 input_tokens = 1;
   */
  inputTokens: bigint;

  /**
   * Number of cached input tokens used
   *
   * @generated from field: uint64 cached_input_tokens = 2;
   */
  cachedInputTokens: bigint;

  /**
   * Number of tokens used for cache input creation
   *
   * @generated from field: uint64 cache_input_creation_tokens = 3;
   */
  cacheInputCreationTokens: bigint;

  /**
   * Number of output tokens generated
   *
   * @generated from field: uint64 output_tokens = 4;
   */
  outputTokens: bigint;

  /**
   * Number of ephemeral 1-hour input tokens used
   *
   * @generated from field: uint64 ephemeral_1h_input_tokens = 5;
   */
  ephemeral1hInputTokens: bigint;

  /**
   * Number of ephemeral 5-minute input tokens used
   *
   * @generated from field: uint64 ephemeral_5m_input_tokens = 6;
   */
  ephemeral5mInputTokens: bigint;
};

/**
 * Describes the message gitpod.v1.LLMUsage.
 * Use `create(LLMUsageSchema)` to create a new message.
 */
export const LLMUsageSchema: GenMessage<LLMUsage> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 71);

/**
 * @generated from message gitpod.v1.ReportLLMUsageResponse
 */
export type ReportLLMUsageResponse = Message<"gitpod.v1.ReportLLMUsageResponse"> & {
};

/**
 * Describes the message gitpod.v1.ReportLLMUsageResponse.
 * Use `create(ReportLLMUsageResponseSchema)` to create a new message.
 */
export const ReportLLMUsageResponseSchema: GenMessage<ReportLLMUsageResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 72);

/**
 * @generated from message gitpod.v1.ReportRunnerMetricsRequest
 */
export type ReportRunnerMetricsRequest = Message<"gitpod.v1.ReportRunnerMetricsRequest"> & {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * Snappy-compressed Prometheus remote-write WriteRequest protobuf.
   * Maximum 512 KB compressed.
   *
   * @generated from field: bytes compressed_metrics = 2;
   */
  compressedMetrics: Uint8Array;
};

/**
 * Describes the message gitpod.v1.ReportRunnerMetricsRequest.
 * Use `create(ReportRunnerMetricsRequestSchema)` to create a new message.
 */
export const ReportRunnerMetricsRequestSchema: GenMessage<ReportRunnerMetricsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 73);

/**
 * @generated from message gitpod.v1.ReportRunnerMetricsResponse
 */
export type ReportRunnerMetricsResponse = Message<"gitpod.v1.ReportRunnerMetricsResponse"> & {
};

/**
 * Describes the message gitpod.v1.ReportRunnerMetricsResponse.
 * Use `create(ReportRunnerMetricsResponseSchema)` to create a new message.
 */
export const ReportRunnerMetricsResponseSchema: GenMessage<ReportRunnerMetricsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 74);

/**
 * @generated from message gitpod.v1.RunnerEnvironmentSnapshot
 */
export type RunnerEnvironmentSnapshot = Message<"gitpod.v1.RunnerEnvironmentSnapshot"> & {
  /**
   * ID is a unique identifier of this snapshot
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Metadata is data associated with this snapshot
   *
   * @generated from field: gitpod.v1.RunnerEnvironmentSnapshotMetadata metadata = 2;
   */
  metadata?: RunnerEnvironmentSnapshotMetadata;

  /**
   * Spec is the configuration used to create this snapshot
   *
   * @generated from field: gitpod.v1.RunnerEnvironmentSnapshotSpec spec = 3;
   */
  spec?: RunnerEnvironmentSnapshotSpec;

  /**
   * Status is the current status of the snapshot
   *
   * @generated from field: gitpod.v1.RunnerEnvironmentSnapshotStatus status = 4;
   */
  status?: RunnerEnvironmentSnapshotStatus;
};

/**
 * Describes the message gitpod.v1.RunnerEnvironmentSnapshot.
 * Use `create(RunnerEnvironmentSnapshotSchema)` to create a new message.
 */
export const RunnerEnvironmentSnapshotSchema: GenMessage<RunnerEnvironmentSnapshot> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 75);

/**
 * SnapshotMetadata contains metadata about the snapshot
 *
 * @generated from message gitpod.v1.RunnerEnvironmentSnapshotMetadata
 */
export type RunnerEnvironmentSnapshotMetadata = Message<"gitpod.v1.RunnerEnvironmentSnapshotMetadata"> & {
  /**
   * organization_id is the ID of the organization that owns the snapshot
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * environment_id is the ID of the environment that was snapshotted
   *
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * environment_spec is the specification of the environment that was snapshotted
   *
   * @generated from field: gitpod.v1.EnvironmentSpec environment_spec = 3;
   */
  environmentSpec?: EnvironmentSpec;

  /**
   * runner_id is the ID of the runner that created the snapshot
   *
   * @generated from field: string runner_id = 4;
   */
  runnerId: string;

  /**
   * created_at is when the snapshot creation was initiated
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * project_id is the ID of the project that the snapshot belongs to
   *
   * @generated from field: optional string project_id = 6;
   */
  projectId?: string;
};

/**
 * Describes the message gitpod.v1.RunnerEnvironmentSnapshotMetadata.
 * Use `create(RunnerEnvironmentSnapshotMetadataSchema)` to create a new message.
 */
export const RunnerEnvironmentSnapshotMetadataSchema: GenMessage<RunnerEnvironmentSnapshotMetadata> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 76);

/**
 * SnapshotSpec specifies the configuration for creating a snapshot
 *
 * @generated from message gitpod.v1.RunnerEnvironmentSnapshotSpec
 */
export type RunnerEnvironmentSnapshotSpec = Message<"gitpod.v1.RunnerEnvironmentSnapshotSpec"> & {
  /**
   * provider_config contains provider-specific configuration
   *
   * @generated from field: map<string, string> provider_config = 1;
   */
  providerConfig: { [key: string]: string };

  /**
   * desired_phase specifies the intended lifecycle phase for this snapshot
   *
   * @generated from field: gitpod.v1.RunnerEnvironmentSnapshotPhase desired_phase = 2;
   */
  desiredPhase: RunnerEnvironmentSnapshotPhase;
};

/**
 * Describes the message gitpod.v1.RunnerEnvironmentSnapshotSpec.
 * Use `create(RunnerEnvironmentSnapshotSpecSchema)` to create a new message.
 */
export const RunnerEnvironmentSnapshotSpecSchema: GenMessage<RunnerEnvironmentSnapshotSpec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 77);

/**
 * SnapshotStatus describes the current status of a snapshot
 *
 * @generated from message gitpod.v1.RunnerEnvironmentSnapshotStatus
 */
export type RunnerEnvironmentSnapshotStatus = Message<"gitpod.v1.RunnerEnvironmentSnapshotStatus"> & {
  /**
   * phase is the current phase of the snapshot lifecycle
   *
   * @generated from field: gitpod.v1.RunnerEnvironmentSnapshotPhase phase = 1;
   */
  phase: RunnerEnvironmentSnapshotPhase;

  /**
   * size_bytes is the size of the snapshot in bytes (available when completed)
   *
   * @generated from field: int64 size_bytes = 2;
   */
  sizeBytes: bigint;

  /**
   * progress contains information about snapshot creation progress
   *
   * @generated from field: int32 completion_percentage = 3;
   */
  completionPercentage: number;

  /**
   * provider_snapshot contains provider-specific snapshot details
   *
   * @generated from field: gitpod.v1.RunnerEnvironmentSnapshotStatus.ProviderSnapshot provider_snapshot = 4;
   */
  providerSnapshot?: RunnerEnvironmentSnapshotStatus_ProviderSnapshot;

  /**
   * failure_message contains details about why the snapshot failed
   *
   * @generated from field: string failure_message = 5;
   */
  failureMessage: string;

  /**
   * completed_at is when the snapshot creation was completed (if successful)
   *
   * @generated from field: google.protobuf.Timestamp completed_at = 6;
   */
  completedAt?: Timestamp;

  /**
   * logs_url is the URL to access the environment logs for this snapshot
   *
   * @generated from field: string logs_url = 7;
   */
  logsUrl: string;
};

/**
 * Describes the message gitpod.v1.RunnerEnvironmentSnapshotStatus.
 * Use `create(RunnerEnvironmentSnapshotStatusSchema)` to create a new message.
 */
export const RunnerEnvironmentSnapshotStatusSchema: GenMessage<RunnerEnvironmentSnapshotStatus> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 78);

/**
 * ProviderSnapshot contains provider-specific snapshot information
 *
 * @generated from message gitpod.v1.RunnerEnvironmentSnapshotStatus.ProviderSnapshot
 */
export type RunnerEnvironmentSnapshotStatus_ProviderSnapshot = Message<"gitpod.v1.RunnerEnvironmentSnapshotStatus.ProviderSnapshot"> & {
  /**
   * provider_snapshot_id is the ID assigned by the cloud provider
   *
   * @generated from field: string provider_snapshot_id = 1;
   */
  providerSnapshotId: string;

  /**
   * provider_name is the name of the cloud provider (e.g., "aws", "gcp", "azure")
   *
   * @generated from field: string provider_name = 2;
   */
  providerName: string;

  /**
   * region is the cloud provider region where the snapshot is stored
   *
   * @generated from field: string region = 3;
   */
  region: string;
};

/**
 * Describes the message gitpod.v1.RunnerEnvironmentSnapshotStatus.ProviderSnapshot.
 * Use `create(RunnerEnvironmentSnapshotStatus_ProviderSnapshotSchema)` to create a new message.
 */
export const RunnerEnvironmentSnapshotStatus_ProviderSnapshotSchema: GenMessage<RunnerEnvironmentSnapshotStatus_ProviderSnapshot> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 78, 0);

/**
 * @generated from message gitpod.v1.GetRunnerEnvironmentSnapshotRequest
 */
export type GetRunnerEnvironmentSnapshotRequest = Message<"gitpod.v1.GetRunnerEnvironmentSnapshotRequest"> & {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * snapshot_id specifies the snapshot to retrieve
   *
   * @generated from field: string snapshot_id = 2;
   */
  snapshotId: string;
};

/**
 * Describes the message gitpod.v1.GetRunnerEnvironmentSnapshotRequest.
 * Use `create(GetRunnerEnvironmentSnapshotRequestSchema)` to create a new message.
 */
export const GetRunnerEnvironmentSnapshotRequestSchema: GenMessage<GetRunnerEnvironmentSnapshotRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 79);

/**
 * @generated from message gitpod.v1.GetRunnerEnvironmentSnapshotResponse
 */
export type GetRunnerEnvironmentSnapshotResponse = Message<"gitpod.v1.GetRunnerEnvironmentSnapshotResponse"> & {
  /**
   * @generated from field: gitpod.v1.RunnerEnvironmentSnapshot snapshot = 1;
   */
  snapshot?: RunnerEnvironmentSnapshot;
};

/**
 * Describes the message gitpod.v1.GetRunnerEnvironmentSnapshotResponse.
 * Use `create(GetRunnerEnvironmentSnapshotResponseSchema)` to create a new message.
 */
export const GetRunnerEnvironmentSnapshotResponseSchema: GenMessage<GetRunnerEnvironmentSnapshotResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 80);

/**
 * @generated from message gitpod.v1.ListRunnerEnvironmentSnapshotsRequest
 */
export type ListRunnerEnvironmentSnapshotsRequest = Message<"gitpod.v1.ListRunnerEnvironmentSnapshotsRequest"> & {
  /**
   * pagination contains the pagination options for listing snapshots
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * The runner's identifier
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId: string;

  /**
   * filter contains the filter options for listing snapshots
   *
   * @generated from field: gitpod.v1.ListRunnerEnvironmentSnapshotsRequest.Filter filter = 3;
   */
  filter?: ListRunnerEnvironmentSnapshotsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListRunnerEnvironmentSnapshotsRequest.
 * Use `create(ListRunnerEnvironmentSnapshotsRequestSchema)` to create a new message.
 */
export const ListRunnerEnvironmentSnapshotsRequestSchema: GenMessage<ListRunnerEnvironmentSnapshotsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 81);

/**
 * @generated from message gitpod.v1.ListRunnerEnvironmentSnapshotsRequest.Filter
 */
export type ListRunnerEnvironmentSnapshotsRequest_Filter = Message<"gitpod.v1.ListRunnerEnvironmentSnapshotsRequest.Filter"> & {
  /**
   * @generated from field: repeated string snapshot_ids = 1;
   */
  snapshotIds: string[];
};

/**
 * Describes the message gitpod.v1.ListRunnerEnvironmentSnapshotsRequest.Filter.
 * Use `create(ListRunnerEnvironmentSnapshotsRequest_FilterSchema)` to create a new message.
 */
export const ListRunnerEnvironmentSnapshotsRequest_FilterSchema: GenMessage<ListRunnerEnvironmentSnapshotsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 81, 0);

/**
 * @generated from message gitpod.v1.ListRunnerEnvironmentSnapshotsResponse
 */
export type ListRunnerEnvironmentSnapshotsResponse = Message<"gitpod.v1.ListRunnerEnvironmentSnapshotsResponse"> & {
  /**
   * pagination contains the pagination response
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * snapshots are the snapshots that matched the query
   *
   * @generated from field: repeated gitpod.v1.RunnerEnvironmentSnapshot snapshots = 2;
   */
  snapshots: RunnerEnvironmentSnapshot[];
};

/**
 * Describes the message gitpod.v1.ListRunnerEnvironmentSnapshotsResponse.
 * Use `create(ListRunnerEnvironmentSnapshotsResponseSchema)` to create a new message.
 */
export const ListRunnerEnvironmentSnapshotsResponseSchema: GenMessage<ListRunnerEnvironmentSnapshotsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 82);

/**
 * @generated from message gitpod.v1.UpdateRunnerEnvironmentSnapshotStatusRequest
 */
export type UpdateRunnerEnvironmentSnapshotStatusRequest = Message<"gitpod.v1.UpdateRunnerEnvironmentSnapshotStatusRequest"> & {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * snapshot_id specifies the snapshot to delete
   *
   * @generated from field: string snapshot_id = 2;
   */
  snapshotId: string;

  /**
   * status is the new status for the snapshot
   *
   * @generated from field: gitpod.v1.RunnerEnvironmentSnapshotStatus status = 3;
   */
  status?: RunnerEnvironmentSnapshotStatus;
};

/**
 * Describes the message gitpod.v1.UpdateRunnerEnvironmentSnapshotStatusRequest.
 * Use `create(UpdateRunnerEnvironmentSnapshotStatusRequestSchema)` to create a new message.
 */
export const UpdateRunnerEnvironmentSnapshotStatusRequestSchema: GenMessage<UpdateRunnerEnvironmentSnapshotStatusRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 83);

/**
 * @generated from message gitpod.v1.UpdateRunnerEnvironmentSnapshotStatusResponse
 */
export type UpdateRunnerEnvironmentSnapshotStatusResponse = Message<"gitpod.v1.UpdateRunnerEnvironmentSnapshotStatusResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateRunnerEnvironmentSnapshotStatusResponse.
 * Use `create(UpdateRunnerEnvironmentSnapshotStatusResponseSchema)` to create a new message.
 */
export const UpdateRunnerEnvironmentSnapshotStatusResponseSchema: GenMessage<UpdateRunnerEnvironmentSnapshotStatusResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 84);

/**
 * @generated from message gitpod.v1.GetRunnerWarmPoolRequest
 */
export type GetRunnerWarmPoolRequest = Message<"gitpod.v1.GetRunnerWarmPoolRequest"> & {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * warm_pool_id specifies the warm pool to retrieve
   *
   * @generated from field: string warm_pool_id = 2;
   */
  warmPoolId: string;
};

/**
 * Describes the message gitpod.v1.GetRunnerWarmPoolRequest.
 * Use `create(GetRunnerWarmPoolRequestSchema)` to create a new message.
 */
export const GetRunnerWarmPoolRequestSchema: GenMessage<GetRunnerWarmPoolRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 85);

/**
 * @generated from message gitpod.v1.GetRunnerWarmPoolResponse
 */
export type GetRunnerWarmPoolResponse = Message<"gitpod.v1.GetRunnerWarmPoolResponse"> & {
  /**
   * @generated from field: gitpod.v1.WarmPool warm_pool = 1;
   */
  warmPool?: WarmPool;
};

/**
 * Describes the message gitpod.v1.GetRunnerWarmPoolResponse.
 * Use `create(GetRunnerWarmPoolResponseSchema)` to create a new message.
 */
export const GetRunnerWarmPoolResponseSchema: GenMessage<GetRunnerWarmPoolResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 86);

/**
 * @generated from message gitpod.v1.ListRunnerWarmPoolsRequest
 */
export type ListRunnerWarmPoolsRequest = Message<"gitpod.v1.ListRunnerWarmPoolsRequest"> & {
  /**
   * pagination contains the pagination options for listing warm pools
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId: string;
};

/**
 * Describes the message gitpod.v1.ListRunnerWarmPoolsRequest.
 * Use `create(ListRunnerWarmPoolsRequestSchema)` to create a new message.
 */
export const ListRunnerWarmPoolsRequestSchema: GenMessage<ListRunnerWarmPoolsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 87);

/**
 * @generated from message gitpod.v1.ListRunnerWarmPoolsResponse
 */
export type ListRunnerWarmPoolsResponse = Message<"gitpod.v1.ListRunnerWarmPoolsResponse"> & {
  /**
   * pagination contains the pagination response
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.WarmPool warm_pools = 2;
   */
  warmPools: WarmPool[];
};

/**
 * Describes the message gitpod.v1.ListRunnerWarmPoolsResponse.
 * Use `create(ListRunnerWarmPoolsResponseSchema)` to create a new message.
 */
export const ListRunnerWarmPoolsResponseSchema: GenMessage<ListRunnerWarmPoolsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 88);

/**
 * @generated from message gitpod.v1.UpdateRunnerWarmPoolStatusRequest
 */
export type UpdateRunnerWarmPoolStatusRequest = Message<"gitpod.v1.UpdateRunnerWarmPoolStatusRequest"> & {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * warm_pool_id specifies the warm pool to update
   *
   * @generated from field: string warm_pool_id = 2;
   */
  warmPoolId: string;

  /**
   * status is the new status for the warm pool
   *
   * @generated from field: gitpod.v1.WarmPoolStatus status = 3;
   */
  status?: WarmPoolStatus;
};

/**
 * Describes the message gitpod.v1.UpdateRunnerWarmPoolStatusRequest.
 * Use `create(UpdateRunnerWarmPoolStatusRequestSchema)` to create a new message.
 */
export const UpdateRunnerWarmPoolStatusRequestSchema: GenMessage<UpdateRunnerWarmPoolStatusRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 89);

/**
 * @generated from message gitpod.v1.UpdateRunnerWarmPoolStatusResponse
 */
export type UpdateRunnerWarmPoolStatusResponse = Message<"gitpod.v1.UpdateRunnerWarmPoolStatusResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateRunnerWarmPoolStatusResponse.
 * Use `create(UpdateRunnerWarmPoolStatusResponseSchema)` to create a new message.
 */
export const UpdateRunnerWarmPoolStatusResponseSchema: GenMessage<UpdateRunnerWarmPoolStatusResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_interaction, 90);

/**
 * SnapshotPhase represents the lifecycle phase of a snapshot
 *
 * @generated from enum gitpod.v1.RunnerEnvironmentSnapshotPhase
 */
export enum RunnerEnvironmentSnapshotPhase {
  /**
   * @generated from enum value: RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Pending means the snapshot creation request is queued
   *
   * @generated from enum value: RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_PENDING = 10;
   */
  PENDING = 10,

  /**
   * Creating means the snapshot is currently being created
   *
   * @generated from enum value: RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_CREATING = 20;
   */
  CREATING = 20,

  /**
   * Available means the snapshot is ready for use
   *
   * @generated from enum value: RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_AVAILABLE = 30;
   */
  AVAILABLE = 30,

  /**
   * Failed means the snapshot creation failed
   *
   * @generated from enum value: RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_FAILED = 40;
   */
  FAILED = 40,

  /**
   * Deleting means the snapshot is being deleted
   *
   * @generated from enum value: RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_DELETING = 50;
   */
  DELETING = 50,

  /**
   * Deleted means the snapshot has been deleted
   *
   * @generated from enum value: RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_DELETED = 60;
   */
  DELETED = 60,
}

/**
 * Describes the enum gitpod.v1.RunnerEnvironmentSnapshotPhase.
 */
export const RunnerEnvironmentSnapshotPhaseSchema: GenEnum<RunnerEnvironmentSnapshotPhase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_runner_interaction, 0);

/**
 * RunnerInteractionService provides a way for the backend to interact with environment runners.
 *
 * @generated from service gitpod.v1.RunnerInteractionService
 */
export const RunnerInteractionService: GenService<{
  /**
   * Establishes initial connection between a runner and the Gitpod backend. This is the first
   * call a runner makes to register itself and establish its identity.
   *
   * Use this method to:
   * - Register new runners with the platform
   * - Exchange cryptographic keys for secure communication
   * - Declare supported environment classes and capabilities
   * - Initialize runner configuration
   *
   * ### Examples
   *
   * - Register runner:
   *
   *   Registers a new runner with its public key and supported environment classes.
   *
   *   ```yaml
   *   publicKey: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA"  # 32 bytes of zeros, base64 encoded
   *   environmentClasses:
   *     - id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *       runnerId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
   *       displayName: "Large Instance"
   *       description: "8 CPU, 16GB RAM"
   *       enabled: true
   *       configuration:
   *         - key: "cpu"
   *           value: "8"
   *         - key: "memory"
   *           value: "16384"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.Signup
   */
  signup: {
    methodKind: "unary";
    input: typeof SignupRequestSchema;
    output: typeof SignupResponseSchema;
  },
  /**
   * Maintains the active status of a runner through periodic heartbeat signals. The runner must
   * call this method every 30 seconds to indicate it's healthy and ready to accept workloads.
   *
   * Use this method to:
   * - Keep runners marked as available in the system
   * - Maintain health check status
   * - Prevent automatic deregistration
   * - Signal readiness for new workloads
   *
   * ### Examples
   *
   * - Send heartbeat:
   *
   *   Marks a runner as active and healthy.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.MarkRunnerActive
   */
  markRunnerActive: {
    methodKind: "unary";
    input: typeof MarkRunnerActiveRequestSchema;
    output: typeof MarkRunnerActiveResponseSchema;
  },
  /**
   * Retrieves environment details for a specific runner.
   *
   * Use this method to:
   * - Get environment configuration
   * - Check environment status
   * - Verify environment ownership
   *
   * ### Examples
   *
   * - Get environment:
   *
   *   Retrieves environment details.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.GetRunnerEnvironment
   */
  getRunnerEnvironment: {
    methodKind: "unary";
    input: typeof GetRunnerEnvironmentRequestSchema;
    output: typeof GetRunnerEnvironmentResponseSchema;
  },
  /**
   * Lists all environments managed by a runner.
   *
   * Use this method to:
   * - View assigned environments
   * - Monitor environment status
   * - Check environment assignments
   *
   * ### Examples
   *
   * - List environments:
   *
   *   Shows all environments for a runner.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * - List specific environments:
   *
   *   Shows details for specific environment IDs.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   environmentIds: ["07e03a28-65a5-4d98-b532-8ea67b188048"]
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.ListRunnerEnvironments
   */
  listRunnerEnvironments: {
    methodKind: "unary";
    input: typeof ListRunnerEnvironmentsRequestSchema;
    output: typeof ListRunnerEnvironmentsResponseSchema;
  },
  /**
   * Provides comprehensive status updates about a managed environment. This method allows
   * runners to report detailed state information about environments they're managing.
   *
   * Use this method to:
   * - Report current environment phase and health status
   * - Update machine and container states
   * - Signal content and devcontainer readiness
   * - Provide access URLs and endpoints
   * - Report warnings or failure conditions
   *
   * ### Examples
   *
   * - Update status:
   *
   *   Provides a detailed status update for an environment.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   status:
   *     phase: ENVIRONMENT_PHASE_RUNNING
   *     statusVersion: "1"
   *     failureMessage: []
   *     warningMessage: []
   *     machine:
   *       phase: PHASE_RUNNING
   *     content:
   *       phase: CONTENT_PHASE_READY
   *     devcontainer:
   *       phase: PHASE_RUNNING
   *     environmentUrls:
   *       logs: "https://logs.gitpod.io/environment"
   *       ports: []
   *       ssh:
   *         url: "ssh://ssh.gitpod.io:22"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.UpdateRunnerEnvironmentStatus
   */
  updateRunnerEnvironmentStatus: {
    methodKind: "unary";
    input: typeof UpdateRunnerEnvironmentStatusRequestSchema;
    output: typeof UpdateRunnerEnvironmentStatusResponseSchema;
  },
  /**
   * Updates the runner's status and capabilities.
   *
   * Use this method to:
   * - Report runner health
   * - Update version information
   * - Signal system changes
   * - Configure capabilities
   *
   * ### Examples
   *
   * - Update status:
   *
   *   Updates runner status and details.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   version: "1.2.3"
   *   systemDetails: "Linux x86_64"
   *   logUrl: "https://logs.example.com/runner"
   *   region: "us-west"
   *   capabilities: ["RUNNER_CAPABILITY_SECRET_CONTAINER_REGISTRY"]
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.UpdateRunnerStatus
   */
  updateRunnerStatus: {
    methodKind: "unary";
    input: typeof UpdateRunnerStatusRequestSchema;
    output: typeof UpdateRunnerStatusResponseSchema;
  },
  /**
   * Updates the configuration schema for a runner.
   *
   * Use this method to:
   * - Define configuration options
   * - Update schema definitions
   * - Set validation rules
   *
   * ### Examples
   *
   * - Update schema:
   *
   *   Updates runner configuration schema.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   configSchema:
   *     version: "1.0"
   *     runnerConfig:
   *       - id: "region"
   *         name: "Region"
   *         description: "Deployment region"
   *         required: true
   *         string:
   *           default: "us-west"
   *           pattern: "^[a-z]+-[a-z]+-[0-9]+$"
   *       - id: "autoUpdate"
   *         name: "Auto Update"
   *         description: "Enable automatic updates"
   *         required: true
   *         bool:
   *           default: true
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.UpdateRunnerConfigurationSchema
   */
  updateRunnerConfigurationSchema: {
    methodKind: "unary";
    input: typeof UpdateRunnerConfigurationSchemaRequestSchema;
    output: typeof UpdateRunnerConfigurationSchemaResponseSchema;
  },
  /**
   * Retrieves authentication token for accessing remote hosts.
   *
   * Use this method to:
   * - Get host credentials
   * - Access SCM tokens
   * - Verify authentication
   *
   * ### Examples
   *
   * - Get token:
   *
   *   Retrieves authentication token for a host.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   principalId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
   *   host: "github.com"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.GetHostAuthenticationTokenValue
   */
  getHostAuthenticationTokenValue: {
    methodKind: "unary";
    input: typeof GetHostAuthenticationTokenValueRequestSchema;
    output: typeof GetHostAuthenticationTokenValueResponseSchema;
  },
  /**
   * Lists environment classes configured for a runner.
   *
   * Use this method to:
   * - View available classes
   * - Check class configurations
   * - Monitor class status
   *
   * ### Examples
   *
   * - List classes:
   *
   *   Shows environment classes for a runner.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.ListRunnerEnvironmentClasses
   */
  listRunnerEnvironmentClasses: {
    methodKind: "unary";
    input: typeof ListRunnerEnvironmentClassesRequestSchema;
    output: typeof ListRunnerEnvironmentClassesResponseSchema;
  },
  /**
   * Lists SCM integrations configured for a runner.
   *
   * Use this method to:
   * - View SCM configurations
   * - Check integration status
   * - Monitor available SCMs
   *
   * ### Examples
   *
   * - List integrations:
   *
   *   Shows SCM integrations for a runner.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.ListRunnerSCMIntegrations
   */
  listRunnerSCMIntegrations: {
    methodKind: "unary";
    input: typeof ListRunnerSCMIntegrationsRequestSchema;
    output: typeof ListRunnerSCMIntegrationsResponseSchema;
  },
  /**
   * Streams requests that need to be handled by the runner.
   *
   * Use this method to:
   * - Receive configuration changes
   * - Handle environment updates
   * - Process integration events
   * - Monitor real-time events
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.WatchRequests
   */
  watchRequests: {
    methodKind: "server_streaming";
    input: typeof WatchRequestsRequestSchema;
    output: typeof WatchRequestsResponseSchema;
  },
  /**
   * Sends a response to a previously received request.
   *
   * Use this method to:
   * - Respond to requests
   * - Report operation results
   * - Handle errors
   *
   * ### Examples
   *
   * - Send response:
   *
   *   Responds to a request.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   requestId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   callParseContext:
   *     resp:
   *       originalContextUrl: "https://github.com/org/repo"
   *       git:
   *         host: "github.com"
   *         owner: "org"
   *         repo: "repo"
   *         branch: "main"
   *         cloneUrl: "https://github.com/org/repo.git"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.SendResponse
   */
  sendResponse: {
    methodKind: "unary";
    input: typeof SendResponseRequestSchema;
    output: typeof SendResponseResponseSchema;
  },
  /**
   * Gets the latest version information for a runner.
   *
   * Use this method to:
   * - Check for updates
   * - Get version details
   * - Verify compatibility
   *
   * ### Examples
   *
   * - Get version:
   *
   *   Retrieves latest version info.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   currentVersion: "1.2.3"
   *   infrastructureVersion: "4.5.6"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.GetLatestVersion
   */
  getLatestVersion: {
    methodKind: "unary";
    input: typeof GetLatestVersionRequestSchema;
    output: typeof GetLatestVersionResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.RunnerInteractionService.GetRunnerConfiguration
   */
  getRunnerConfiguration: {
    methodKind: "unary";
    input: typeof GetRunnerConfigurationRequestSchema;
    output: typeof GetRunnerConfigurationResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.RunnerInteractionService.ListRunnerAgentExecutions
   */
  listRunnerAgentExecutions: {
    methodKind: "unary";
    input: typeof ListRunnerAgentExecutionsRequestSchema;
    output: typeof ListRunnerAgentExecutionsResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.RunnerInteractionService.GetRunnerAgentExecution
   */
  getRunnerAgentExecution: {
    methodKind: "unary";
    input: typeof GetRunnerAgentExecutionRequestSchema;
    output: typeof GetRunnerAgentExecutionResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.RunnerInteractionService.UpdateRunnerAgentExecution
   */
  updateRunnerAgentExecution: {
    methodKind: "unary";
    input: typeof UpdateRunnerAgentExecutionRequestSchema;
    output: typeof UpdateRunnerAgentExecutionResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.RunnerInteractionService.GetRunnerLLMIntegration
   */
  getRunnerLLMIntegration: {
    methodKind: "unary";
    input: typeof GetRunnerLLMIntegrationRequestSchema;
    output: typeof GetRunnerLLMIntegrationResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.RunnerInteractionService.ListRunnerLLMIntegrations
   */
  listRunnerLLMIntegrations: {
    methodKind: "unary";
    input: typeof ListRunnerLLMIntegrationsRequestSchema;
    output: typeof ListRunnerLLMIntegrationsResponseSchema;
  },
  /**
   * Lists integrations configured for a runner.
   *
   * Use this method to:
   * - View available integrations
   * - Check integration configurations
   * - Monitor integration status
   *
   * ### Examples
   *
   * - List integrations:
   *
   *   Shows integrations for a runner.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.ListRunnerIntegrations
   */
  listRunnerIntegrations: {
    methodKind: "unary";
    input: typeof ListRunnerIntegrationsRequestSchema;
    output: typeof ListRunnerIntegrationsResponseSchema;
  },
  /**
   * Lists all runners managed by this runner manager.
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.ListManagedRunners
   */
  listManagedRunners: {
    methodKind: "unary";
    input: typeof ListManagedRunnersRequestSchema;
    output: typeof ListManagedRunnersResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.RunnerInteractionService.GetManagedRunner
   */
  getManagedRunner: {
    methodKind: "unary";
    input: typeof GetManagedRunnerRequestSchema;
    output: typeof GetManagedRunnerResponseSchema;
  },
  /**
   * Watches for changes to managed runners.
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.WatchManagedRunners
   */
  watchManagedRunners: {
    methodKind: "server_streaming";
    input: typeof WatchManagedRunnersRequestSchema;
    output: typeof WatchManagedRunnersResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.RunnerInteractionService.ReportLLMUsage
   */
  reportLLMUsage: {
    methodKind: "unary";
    input: typeof ReportLLMUsageRequestSchema;
    output: typeof ReportLLMUsageResponseSchema;
  },
  /**
   * Reports runner operational metrics to the management plane for forwarding
   * to Grafana Cloud. The runner gathers metrics from its local Prometheus
   * registry, encodes them as a Prometheus WriteRequest protobuf, and
   * Snappy-compresses the payload.
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.ReportRunnerMetrics
   */
  reportRunnerMetrics: {
    methodKind: "unary";
    input: typeof ReportRunnerMetricsRequestSchema;
    output: typeof ReportRunnerMetricsResponseSchema;
  },
  /**
   * Gets details about a specific snapshot including its status, size, and metadata.
   *
   * Use this method to:
   * - Check if a snapshot is ready for use
   * - Monitor snapshot creation progress
   * - Get snapshot size and creation details
   * - Retrieve provider-specific snapshot information
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.GetRunnerEnvironmentSnapshot
   */
  getRunnerEnvironmentSnapshot: {
    methodKind: "unary";
    input: typeof GetRunnerEnvironmentSnapshotRequestSchema;
    output: typeof GetRunnerEnvironmentSnapshotResponseSchema;
  },
  /**
   * Lists all snapshots matching the specified criteria.
   *
   * Use this method to find and monitor snapshots across your organization.
   * Results are ordered by creation time with newest snapshots first.
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.ListRunnerEnvironmentSnapshots
   */
  listRunnerEnvironmentSnapshots: {
    methodKind: "unary";
    input: typeof ListRunnerEnvironmentSnapshotsRequestSchema;
    output: typeof ListRunnerEnvironmentSnapshotsResponseSchema;
  },
  /**
   * Updates the status of a snapshot during its lifecycle.
   *
   * Use this method to:
   * - Report snapshot creation progress
   * - Update completion percentage
   * - Set snapshot phase (pending, creating, available, failed)
   * - Provide provider-specific snapshot details
   * - Report failure messages when snapshot creation fails
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.UpdateRunnerEnvironmentSnapshotStatus
   */
  updateRunnerEnvironmentSnapshotStatus: {
    methodKind: "unary";
    input: typeof UpdateRunnerEnvironmentSnapshotStatusRequestSchema;
    output: typeof UpdateRunnerEnvironmentSnapshotStatusResponseSchema;
  },
  /**
   * Gets details about a specific warm pool assigned to this runner.
   *
   * Use this method to read the full warm pool spec after receiving
   * an EventWarmPoolSpecChange event.
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.GetRunnerWarmPool
   */
  getRunnerWarmPool: {
    methodKind: "unary";
    input: typeof GetRunnerWarmPoolRequestSchema;
    output: typeof GetRunnerWarmPoolResponseSchema;
  },
  /**
   * Lists all warm pools assigned to this runner.
   *
   * Use this method on startup to discover all warm pools the runner
   * should be managing.
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.ListRunnerWarmPools
   */
  listRunnerWarmPools: {
    methodKind: "unary";
    input: typeof ListRunnerWarmPoolsRequestSchema;
    output: typeof ListRunnerWarmPoolsResponseSchema;
  },
  /**
   * Updates the status of a warm pool.
   *
   * Use this method to:
   * - Report warm pool phase transitions (ready, degraded)
   * - Report failure messages when pool instances cannot be created
   *
   * @generated from rpc gitpod.v1.RunnerInteractionService.UpdateRunnerWarmPoolStatus
   */
  updateRunnerWarmPoolStatus: {
    methodKind: "unary";
    input: typeof UpdateRunnerWarmPoolStatusRequestSchema;
    output: typeof UpdateRunnerWarmPoolStatusResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_runner_interaction, 0);

